var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankingImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2192 1504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-2{mix-blend-mode:multiply;fill:url(#linear-gradient);}.cls-3{fill:none;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#91b3fa;}.cls-6{fill:#dce5fe;}.cls-7{opacity:0.98;}.cls-8{fill:#bdd0fb;}.cls-9{fill:#7d97f4;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12,.cls-168,.cls-186,.cls-199,.cls-30,.cls-48,.cls-54,.cls-77{fill:#fff;}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:#18174a;}.cls-26{fill:#2b69b3;}.cls-27{mask:url(#mask-2);}.cls-28{fill:url(#linear-gradient-17);}.cls-29{fill:url(#linear-gradient-18);}.cls-30{opacity:0.66;}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:url(#linear-gradient-21);}.cls-34{fill:url(#linear-gradient-22);}.cls-35{fill:url(#linear-gradient-23);}.cls-36{fill:url(#linear-gradient-24);}.cls-37{fill:url(#linear-gradient-25);}.cls-38{fill:url(#linear-gradient-26);}.cls-39{fill:url(#linear-gradient-27);}.cls-40{fill:url(#linear-gradient-28);}.cls-41{fill:url(#linear-gradient-29);}.cls-42{fill:url(#linear-gradient-30);}.cls-43{fill:url(#linear-gradient-31);}.cls-44{fill:url(#linear-gradient-32);}.cls-45{fill:url(#linear-gradient-33);}.cls-46{fill:url(#linear-gradient-34);}.cls-47{fill:url(#_57);}.cls-48{opacity:0.56;}.cls-49{fill:url(#linear-gradient-35);}.cls-50{fill:url(#linear-gradient-36);}.cls-51{fill:url(#linear-gradient-37);}.cls-52{fill:url(#linear-gradient-38);}.cls-53{fill:url(#linear-gradient-39);}.cls-54{opacity:0.65;}.cls-55{fill:url(#linear-gradient-40);}.cls-56{fill:url(#linear-gradient-41);}.cls-57{fill:url(#linear-gradient-42);}.cls-58{fill:url(#linear-gradient-43);}.cls-59{fill:url(#linear-gradient-44);}.cls-60{fill:url(#linear-gradient-45);}.cls-61{fill:url(#linear-gradient-46);}.cls-62{fill:url(#linear-gradient-47);}.cls-63{fill:url(#linear-gradient-48);}.cls-64{fill:url(#linear-gradient-49);}.cls-65{fill:url(#linear-gradient-50);}.cls-66{fill:url(#linear-gradient-51);}.cls-67{fill:url(#linear-gradient-52);}.cls-68{fill:url(#linear-gradient-53);}.cls-69{fill:url(#linear-gradient-54);}.cls-70{fill:url(#linear-gradient-55);}.cls-71{fill:url(#linear-gradient-56);}.cls-72{fill:url(#linear-gradient-57);}.cls-73{fill:url(#linear-gradient-58);}.cls-74{fill:url(#linear-gradient-59);}.cls-75{fill:url(#linear-gradient-60);}.cls-76{fill:url(#linear-gradient-61);}.cls-77{opacity:0.67;}.cls-78{fill:url(#linear-gradient-62);}.cls-79{fill:url(#linear-gradient-63);}.cls-80{fill:url(#linear-gradient-64);}.cls-81{fill:url(#linear-gradient-65);}.cls-82{fill:url(#linear-gradient-66);}.cls-83{fill:url(#linear-gradient-67);}.cls-84{fill:url(#linear-gradient-68);}.cls-85{fill:url(#linear-gradient-69);}.cls-86{fill:url(#linear-gradient-70);}.cls-87{fill:url(#linear-gradient-71);}.cls-88{fill:url(#linear-gradient-72);}.cls-89{fill:url(#linear-gradient-73);}.cls-90{fill:url(#linear-gradient-74);}.cls-91{fill:url(#linear-gradient-75);}.cls-92{fill:url(#linear-gradient-76);}.cls-93{fill:url(#linear-gradient-77);}.cls-94{fill:url(#linear-gradient-78);}.cls-95{fill:url(#linear-gradient-79);}.cls-96{fill:url(#linear-gradient-80);}.cls-97{fill:url(#linear-gradient-81);}.cls-98{fill:url(#linear-gradient-82);}.cls-99{fill:url(#linear-gradient-83);}.cls-100{fill:url(#linear-gradient-84);}.cls-101{fill:url(#linear-gradient-85);}.cls-102{fill:url(#linear-gradient-86);}.cls-103{fill:url(#linear-gradient-87);}.cls-104{fill:url(#linear-gradient-88);}.cls-105{fill:url(#linear-gradient-89);}.cls-106{fill:url(#linear-gradient-90);}.cls-107{fill:url(#linear-gradient-91);}.cls-108{fill:url(#linear-gradient-92);}.cls-109{fill:url(#linear-gradient-93);}.cls-110{fill:url(#linear-gradient-94);}.cls-111{fill:url(#linear-gradient-95);}.cls-112{fill:url(#linear-gradient-96);}.cls-113{fill:url(#linear-gradient-97);}.cls-114{fill:url(#linear-gradient-98);}.cls-115{fill:url(#linear-gradient-99);}.cls-116{fill:url(#linear-gradient-100);}.cls-117{fill:url(#linear-gradient-101);}.cls-118{fill:url(#linear-gradient-102);}.cls-119{fill:url(#linear-gradient-103);}.cls-120{fill:url(#linear-gradient-104);}.cls-121{fill:url(#linear-gradient-105);}.cls-122{fill:url(#linear-gradient-106);}.cls-123{fill:url(#linear-gradient-107);}.cls-124{fill:url(#linear-gradient-108);}.cls-125{fill:url(#linear-gradient-109);}.cls-126{fill:url(#linear-gradient-110);}.cls-127{fill:url(#linear-gradient-111);}.cls-128{fill:url(#linear-gradient-112);}.cls-129{fill:url(#linear-gradient-113);}.cls-130{fill:url(#linear-gradient-114);}.cls-131{fill:url(#linear-gradient-115);}.cls-132{fill:url(#linear-gradient-116);}.cls-133{fill:url(#linear-gradient-117);}.cls-134{fill:url(#linear-gradient-118);}.cls-135{fill:url(#linear-gradient-119);}.cls-136{fill:url(#linear-gradient-120);}.cls-137{fill:url(#linear-gradient-121);}.cls-138{fill:url(#linear-gradient-122);}.cls-139{fill:url(#linear-gradient-123);}.cls-140{fill:url(#linear-gradient-124);}.cls-141{fill:url(#linear-gradient-125);}.cls-142{fill:url(#linear-gradient-126);}.cls-143{fill:url(#linear-gradient-127);}.cls-144{fill:url(#linear-gradient-128);}.cls-145{fill:url(#linear-gradient-129);}.cls-146{fill:url(#linear-gradient-130);}.cls-147{fill:url(#linear-gradient-131);}.cls-148{fill:url(#linear-gradient-132);}.cls-149{fill:url(#linear-gradient-133);}.cls-150{fill:url(#linear-gradient-134);}.cls-151{fill:url(#linear-gradient-135);}.cls-152{fill:url(#linear-gradient-136);}.cls-153{fill:url(#linear-gradient-137);}.cls-154{fill:url(#linear-gradient-138);}.cls-155{fill:url(#linear-gradient-139);}.cls-156{fill:url(#linear-gradient-140);}.cls-157{fill:url(#linear-gradient-141);}.cls-158{fill:url(#linear-gradient-142);}.cls-159{fill:url(#linear-gradient-143);}.cls-160{fill:url(#linear-gradient-144);}.cls-161{fill:url(#linear-gradient-145);}.cls-162{fill:url(#linear-gradient-146);}.cls-163{fill:url(#linear-gradient-147);}.cls-164{fill:url(#linear-gradient-148);}.cls-165{fill:url(#linear-gradient-149);}.cls-166{fill:url(#linear-gradient-150);}.cls-167{fill:url(#linear-gradient-151);}.cls-168{opacity:0.8;}.cls-169{fill:url(#linear-gradient-152);}.cls-170{fill:url(#linear-gradient-153);}.cls-171{fill:url(#linear-gradient-154);}.cls-172{fill:url(#linear-gradient-155);}.cls-173{fill:url(#linear-gradient-156);}.cls-174{fill:url(#linear-gradient-157);}.cls-175{fill:url(#linear-gradient-158);}.cls-176{fill:url(#linear-gradient-159);}.cls-177{fill:url(#linear-gradient-160);}.cls-178{fill:url(#linear-gradient-161);}.cls-179{fill:url(#linear-gradient-162);}.cls-180{fill:url(#linear-gradient-163);}.cls-181{fill:url(#linear-gradient-164);}.cls-182{clip-path:url(#clip-path);}.cls-183{fill:url(#linear-gradient-165);}.cls-184{fill:url(#linear-gradient-166);}.cls-185{fill:url(#linear-gradient-167);}.cls-186{opacity:0.5;}.cls-187{fill:url(#linear-gradient-168);}.cls-188{fill:url(#linear-gradient-169);}.cls-189{fill:url(#linear-gradient-170);}.cls-190{fill:url(#linear-gradient-171);}.cls-191{fill:url(#linear-gradient-172);}.cls-192{fill:url(#linear-gradient-173);}.cls-193{fill:url(#linear-gradient-174);}.cls-194{fill:url(#linear-gradient-175);}.cls-195{fill:url(#linear-gradient-176);}.cls-196{fill:url(#linear-gradient-177);}.cls-197{fill:url(#linear-gradient-178);}.cls-198{fill:url(#linear-gradient-179);}.cls-199{opacity:0.72;}.cls-200{fill:url(#linear-gradient-180);}.cls-201{fill:url(#linear-gradient-181);}.cls-202{fill:url(#linear-gradient-182);}.cls-203{fill:url(#linear-gradient-183);}.cls-204{fill:url(#linear-gradient-184);}.cls-205{fill:url(#linear-gradient-185);}.cls-206{fill:url(#linear-gradient-186);}.cls-207{fill:url(#linear-gradient-187);}.cls-208{fill:url(#linear-gradient-188);}.cls-209{fill:url(#linear-gradient-189);}.cls-210{fill:url(#linear-gradient-190);}.cls-211{fill:url(#linear-gradient-191);}.cls-212{fill:url(#linear-gradient-192);}.cls-213{fill:url(#linear-gradient-193);}.cls-214{fill:url(#linear-gradient-194);}.cls-215{fill:url(#linear-gradient-195);}.cls-216{fill:url(#linear-gradient-196);}.cls-217{fill:url(#linear-gradient-197);}.cls-218{fill:url(#linear-gradient-198);}.cls-219{fill:url(#linear-gradient-199);}.cls-220{fill:url(#linear-gradient-200);}.cls-221{fill:url(#linear-gradient-201);}.cls-222{fill:url(#linear-gradient-202);}.cls-223{fill:url(#linear-gradient-203);}.cls-224{fill:url(#linear-gradient-204);}.cls-225{fill:url(#linear-gradient-205);}.cls-226{fill:url(#linear-gradient-206);}.cls-227{fill:url(#linear-gradient-207);}.cls-228{fill:url(#linear-gradient-208);}.cls-229{fill:url(#linear-gradient-209);}.cls-230{fill:url(#linear-gradient-210);}.cls-231{fill:url(#linear-gradient-211);}.cls-232{fill:url(#linear-gradient-212);}.cls-233{fill:url(#linear-gradient-213);}.cls-234{fill:url(#linear-gradient-214);}.cls-235{fill:url(#linear-gradient-215);}.cls-236{fill:url(#linear-gradient-216);}.cls-237{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 1598.93,
    y: -8944,
    width: 44.59,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 1598.93,
    y: -8944,
    width: 44.59,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1598.93,
    y1: 352.47,
    x2: 1643.52,
    y2: 352.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.93,
    y1: 723.82,
    x2: 2142.92,
    y2: 723.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1465.02,
    y1: 267.04,
    x2: 1831.46,
    y2: 267.04,
    gradientTransform: "translate(671.58 -1087.27) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1574.62,
    y1: 214.67,
    x2: 1862.22,
    y2: 214.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1777.59,
    y1: 35.57,
    x2: 1768.59,
    y2: 370.05,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1777.91,
    y1: 35.57,
    x2: 1768.91,
    y2: 370.06,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1683.26,
    y1: 33.03,
    x2: 1674.26,
    y2: 367.51,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1735.32,
    y1: 34.43,
    x2: 1726.32,
    y2: 368.91,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1774.13,
    y1: 35.47,
    x2: 1765.13,
    y2: 369.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1812.55,
    y1: 36.51,
    x2: 1803.55,
    y2: 370.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1621.14,
    y1: 31.36,
    x2: 1612.14,
    y2: 365.84,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1614.56,
    y1: 31.18,
    x2: 1605.56,
    y2: 365.66,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1729.61,
    y1: 34.28,
    x2: 1720.61,
    y2: 368.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1837.9,
    y1: 37.19,
    x2: 1828.91,
    y2: 371.67,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1725.13,
    y1: 34.15,
    x2: 1716.13,
    y2: 368.64,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1810.03,
    y1: 36.44,
    x2: 1801.03,
    y2: 370.92,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 1598.93,
    y: 337.79,
    width: 44.59,
    height: 29.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 1598.93,
    y: 337.79,
    width: 44.59,
    height: 29.36,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1634.58,367.15h-25.94c-3.4,0-6.26-1.93-6.67-4.51l-3-19.12c-.48-3,2.64-5.73,6.66-5.73h31.16c4,0,7,2.58,6.69,5.57l-2.23,19.13C1641,365.13,1638.06,367.15,1634.58,367.15Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1344.28,
    y1: 330.03,
    x2: 1381.45,
    y2: 286.88,
    gradientTransform: "translate(1117.5 -1100.43) rotate(67.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1402.46,
    y1: 255.41,
    x2: 1292.53,
    y2: 421.49,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1399.18,
    y1: 260.16,
    x2: 1340.64,
    y2: 358.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1395.08,
    y1: 329.78,
    x2: 1459.8,
    y2: 254.66,
    gradientTransform: "translate(59.42 -230.78) rotate(9.22)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1496.37,
    y1: 199.86,
    x2: 1304.99,
    y2: 488.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1490.66,
    y1: 208.15,
    x2: 1388.75,
    y2: 379.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1426.44,
    y1: 439.77,
    x2: 1493.04,
    y2: 362.47,
    gradientTransform: "translate(1502.3 -1176.41) rotate(76.72)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1520.35,
    y1: 264.69,
    x2: 1479.69,
    y2: 415.36,
    gradientTransform: "translate(1255.94 -1157.83) rotate(67.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1524.79,
    y1: 314.62,
    x2: 1419.93,
    y2: 490.66,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1508.3,
    y1: 351.06,
    x2: 1557.09,
    y2: 294.42,
    gradientTransform: "translate(141.23 -418.17) rotate(16)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1584.66,
    y1: 253.11,
    x2: 1440.38,
    y2: 471.09,
    gradientTransform: "translate(432.3 -823.08) rotate(34.1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1580.36,
    y1: 259.36,
    x2: 1503.53,
    y2: 388.34,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 901.55,
    y1: 260.96,
    x2: 1259.6,
    y2: 260.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1143.81,
    y1: 247.06,
    x2: 1063.81,
    y2: 321.06,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -5763.73,
    y1: 206.12,
    x2: -5768.63,
    y2: 299.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -4625.87, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -5757.55,
    y1: 314.83,
    x2: -5774.49,
    y2: 415.75,
    gradientTransform: "matrix(1, 0, 0, -1, 6915.44, 785.75)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -5662.16,
    y1: 330.3,
    x2: -5679.1,
    y2: 431.23,
    gradientTransform: "matrix(1, 0, 0, -1, 6720.5, 791.96)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1195.55,
    y1: 171.1,
    x2: 1044.55,
    y2: 404.1,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_57",
    x1: -5774.78,
    y1: 300.05,
    x2: -5790.29,
    y2: 292.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -4625.87, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1115.3,
    y1: 249.96,
    x2: 1037.3,
    y2: 342.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1151.77,
    y1: 128.64,
    x2: 1108.77,
    y2: 271.64,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -5607.66,
    y1: 214.25,
    x2: -5588.54,
    y2: 532.37,
    gradientTransform: "matrix(-1, 0, 0, 1, -4625.87, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 897.99,
    y1: 148.44,
    x2: 935.7,
    y2: 104.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 957,
    y1: 72.75,
    x2: 845.51,
    y2: 241.18,
    gradientTransform: "translate(822.32 -831.46) rotate(76.72)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 953.67,
    y1: 77.58,
    x2: 894.31,
    y2: 177.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 949.51,
    y1: 148.18,
    x2: 1015.14,
    y2: 71.99,
    gradientTransform: "translate(923.2 -944.17) rotate(80.78)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1052.23,
    y1: 16.43,
    x2: 858.15,
    y2: 309.63,
    gradientTransform: "translate(542.01 -831.25) rotate(58.28)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1046.44,
    y1: 24.83,
    x2: 943.1,
    y2: 198.33,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 981.32,
    y1: 259.72,
    x2: 1048.85,
    y2: 181.33,
    gradientTransform: "translate(148.73 -388.22) rotate(22.5)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1087.02,
    y1: 124.16,
    x2: 887.31,
    y2: 425.86,
    gradientTransform: "translate(814.38 -859.31) rotate(67.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1081.06,
    y1: 132.8,
    x2: 974.72,
    y2: 311.33,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1064.33,
    y1: 169.76,
    x2: 1113.81,
    y2: 112.32,
    gradientTransform: "translate(1045.96 -1007.06) rotate(80.78)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1141.77,
    y1: 70.43,
    x2: 995.45,
    y2: 291.48,
    gradientTransform: "translate(790.89 -961.33) rotate(67.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1137.41,
    y1: 76.76,
    x2: 1059.49,
    y2: 207.57,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1742.04,
    y1: 1300.45,
    x2: 1831.8,
    y2: 1300.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 16761.79,
    y1: 1240.81,
    x2: 16702.98,
    y2: 1316.84,
    gradientTransform: "translate(-14789.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1860.28,
    y1: 1209.26,
    x2: 1810.06,
    y2: 1281.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1856.62,
    y1: 1206.7,
    x2: 1806.4,
    y2: 1278.5,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 2036.82,
    y1: 1044.79,
    x2: 1962.82,
    y2: 1116.79,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 2013.77,
    y1: 1843.2,
    x2: 2065.23,
    y2: 1843.2,
    gradientTransform: "translate(-259.57 -208.38) rotate(-12.08)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1943.27,
    y1: 1047.14,
    x2: 2033.27,
    y2: 1061.14,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 2550.58,
    y1: 1062.27,
    x2: 2523.74,
    y2: 1085.05,
    gradientTransform: "translate(-573.98 101.76) rotate(-2.65)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1559.12,
    y1: 1450.66,
    x2: 1579.98,
    y2: 1450.66,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1678.41,
    y1: 1450.66,
    x2: 1699.34,
    y2: 1450.66,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1621.59,
    y1: 1061.84,
    x2: 1484.92,
    y2: 1298.51,
    gradientTransform: "translate(1221.39 -841.36) rotate(45)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1691.61,
    y1: 955.03,
    x2: 1337.25,
    y2: 1490.37,
    gradientTransform: "translate(2405.87 -720.42) rotate(80.78)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1681.04,
    y1: 970.37,
    x2: 1492.35,
    y2: 1287.15,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1678.29,
    y1: 1087.51,
    x2: 1547.79,
    y2: 1296.78,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1611,
    y1: 1055.73,
    x2: 1474.33,
    y2: 1292.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1621.22,
    y1: 1061.63,
    x2: 1484.55,
    y2: 1298.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1631.45,
    y1: 1067.53,
    x2: 1494.78,
    y2: 1304.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1641.67,
    y1: 1073.44,
    x2: 1505,
    y2: 1310.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1651.89,
    y1: 1079.34,
    x2: 1515.23,
    y2: 1316.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1662.12,
    y1: 1085.25,
    x2: 1525.45,
    y2: 1321.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1672.34,
    y1: 1091.15,
    x2: 1535.68,
    y2: 1327.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1682.57,
    y1: 1097.06,
    x2: 1545.9,
    y2: 1333.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1692.79,
    y1: 1102.96,
    x2: 1556.13,
    y2: 1339.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1703.02,
    y1: 1108.86,
    x2: 1566.35,
    y2: 1345.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1713.24,
    y1: 1114.77,
    x2: 1576.58,
    y2: 1351.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1723.47,
    y1: 1120.67,
    x2: 1586.8,
    y2: 1357.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1733.69,
    y1: 1126.58,
    x2: 1597.02,
    y2: 1363.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1678.29,
    y1: 1122.22,
    x2: 1547.79,
    y2: 1331.49,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1626.03,
    y1: 1064.41,
    x2: 1489.36,
    y2: 1301.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1636.25,
    y1: 1070.31,
    x2: 1499.58,
    y2: 1306.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1646.48,
    y1: 1076.21,
    x2: 1509.81,
    y2: 1312.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1656.7,
    y1: 1082.12,
    x2: 1520.03,
    y2: 1318.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1666.92,
    y1: 1088.02,
    x2: 1530.26,
    y2: 1324.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1677.15,
    y1: 1093.93,
    x2: 1540.48,
    y2: 1330.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1687.37,
    y1: 1099.83,
    x2: 1550.71,
    y2: 1336.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1697.6,
    y1: 1105.74,
    x2: 1560.93,
    y2: 1342.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1707.82,
    y1: 1111.64,
    x2: 1571.16,
    y2: 1348.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1718.05,
    y1: 1117.54,
    x2: 1581.38,
    y2: 1354.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1728.27,
    y1: 1123.45,
    x2: 1591.61,
    y2: 1360.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1738.5,
    y1: 1129.35,
    x2: 1601.83,
    y2: 1366.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1748.72,
    y1: 1135.26,
    x2: 1612.06,
    y2: 1371.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1678.29,
    y1: 1156.93,
    x2: 1547.79,
    y2: 1366.2,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1641.06,
    y1: 1073.08,
    x2: 1504.39,
    y2: 1309.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1651.28,
    y1: 1078.99,
    x2: 1514.62,
    y2: 1315.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1661.51,
    y1: 1084.89,
    x2: 1524.84,
    y2: 1321.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1671.73,
    y1: 1090.8,
    x2: 1535.06,
    y2: 1327.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1681.96,
    y1: 1096.7,
    x2: 1545.29,
    y2: 1333.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1692.18,
    y1: 1102.61,
    x2: 1555.51,
    y2: 1339.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1702.4,
    y1: 1108.51,
    x2: 1565.74,
    y2: 1345.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1712.63,
    y1: 1114.41,
    x2: 1575.96,
    y2: 1351.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1722.85,
    y1: 1120.32,
    x2: 1586.19,
    y2: 1356.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1733.08,
    y1: 1126.22,
    x2: 1596.41,
    y2: 1362.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1743.3,
    y1: 1132.13,
    x2: 1606.64,
    y2: 1368.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1753.53,
    y1: 1138.03,
    x2: 1616.86,
    y2: 1374.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1763.75,
    y1: 1143.94,
    x2: 1627.09,
    y2: 1380.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1678.29,
    y1: 1191.63,
    x2: 1547.79,
    y2: 1400.91,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1656.09,
    y1: 1081.76,
    x2: 1519.42,
    y2: 1318.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1666.31,
    y1: 1087.67,
    x2: 1529.65,
    y2: 1324.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1676.54,
    y1: 1093.57,
    x2: 1539.87,
    y2: 1330.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1686.76,
    y1: 1099.48,
    x2: 1550.09,
    y2: 1336.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1696.99,
    y1: 1105.38,
    x2: 1560.32,
    y2: 1342.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1707.21,
    y1: 1111.29,
    x2: 1570.54,
    y2: 1347.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1717.43,
    y1: 1117.19,
    x2: 1580.77,
    y2: 1353.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1727.66,
    y1: 1123.09,
    x2: 1590.99,
    y2: 1359.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1737.88,
    y1: 1129,
    x2: 1601.22,
    y2: 1365.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1748.11,
    y1: 1134.9,
    x2: 1611.44,
    y2: 1371.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1758.33,
    y1: 1140.81,
    x2: 1621.67,
    y2: 1377.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1768.56,
    y1: 1146.71,
    x2: 1631.89,
    y2: 1383.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1778.78,
    y1: 1152.62,
    x2: 1642.12,
    y2: 1389.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1678.29,
    y1: 1226.34,
    x2: 1547.79,
    y2: 1435.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1671.12,
    y1: 1090.44,
    x2: 1534.45,
    y2: 1327.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1681.34,
    y1: 1096.35,
    x2: 1544.68,
    y2: 1333.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1691.57,
    y1: 1102.25,
    x2: 1554.9,
    y2: 1338.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1701.79,
    y1: 1108.16,
    x2: 1565.12,
    y2: 1344.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1712.02,
    y1: 1114.06,
    x2: 1575.35,
    y2: 1350.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1722.24,
    y1: 1119.97,
    x2: 1585.57,
    y2: 1356.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1732.47,
    y1: 1125.87,
    x2: 1595.8,
    y2: 1362.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1742.69,
    y1: 1131.77,
    x2: 1606.02,
    y2: 1368.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1752.91,
    y1: 1137.68,
    x2: 1616.25,
    y2: 1374.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1763.14,
    y1: 1143.58,
    x2: 1626.47,
    y2: 1380.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1773.36,
    y1: 1149.49,
    x2: 1636.7,
    y2: 1386.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1783.59,
    y1: 1155.39,
    x2: 1646.92,
    y2: 1392.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1793.81,
    y1: 1161.3,
    x2: 1657.15,
    y2: 1397.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1678.29,
    y1: 1261.05,
    x2: 1547.79,
    y2: 1470.32,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1686.15,
    y1: 1099.12,
    x2: 1549.48,
    y2: 1335.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1696.37,
    y1: 1105.03,
    x2: 1559.71,
    y2: 1341.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1706.6,
    y1: 1110.93,
    x2: 1569.93,
    y2: 1347.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1716.82,
    y1: 1116.84,
    x2: 1580.16,
    y2: 1353.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 1727.05,
    y1: 1122.74,
    x2: 1590.38,
    y2: 1359.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1737.27,
    y1: 1128.65,
    x2: 1600.6,
    y2: 1365.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1747.5,
    y1: 1134.55,
    x2: 1610.83,
    y2: 1371.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1757.72,
    y1: 1140.45,
    x2: 1621.05,
    y2: 1377.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1767.95,
    y1: 1146.36,
    x2: 1631.28,
    y2: 1383.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1778.17,
    y1: 1152.26,
    x2: 1641.5,
    y2: 1388.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1788.39,
    y1: 1158.17,
    x2: 1651.73,
    y2: 1394.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1798.62,
    y1: 1164.07,
    x2: 1661.95,
    y2: 1400.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 1808.84,
    y1: 1169.97,
    x2: 1672.18,
    y2: 1406.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 2557.5,
    y1: 122.85,
    x2: 2215.57,
    y2: 602.75,
    gradientTransform: "translate(-763.89 150.96) rotate(19.68)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1718.8,
    y1: 683.6,
    x2: 2059.66,
    y2: 683.6,
    gradientTransform: "translate(1036.72 -1135.66) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1768.15,
    y1: 719.08,
    x2: 2068.79,
    y2: 719.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1774.81,
    y1: 677.69,
    x2: 1809.66,
    y2: 677.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 700.35,
    y1: 1035.42,
    x2: 584.47,
    y2: 1079.52,
    gradientTransform: "translate(1224.4 -355.67)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1788.34,
    y1: 627.56,
    x2: 1846.08,
    y2: 560.54,
    gradientTransform: "translate(1267.75 -1281.79) rotate(55.69)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 1878.7,
    y1: 511.66,
    x2: 1707.97,
    y2: 769.59,
    gradientTransform: "translate(348.26 -656.56) rotate(22.2)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 1873.61,
    y1: 519.05,
    x2: 1782.7,
    y2: 671.68,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1867.23,
    y1: 627.16,
    x2: 1967.74,
    y2: 510.5,
    gradientTransform: "translate(936.24 -1244.01) rotate(45)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 2024.54,
    y1: 425.41,
    x2: 1727.33,
    y2: 874.41,
    gradientTransform: "translate(2026.22 -1525.34) rotate(77.12)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 2015.67,
    y1: 438.27,
    x2: 1857.41,
    y2: 703.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 1915.94,
    y1: 797.98,
    x2: 2019.37,
    y2: 677.94,
    gradientTransform: "translate(1997.79 -1455.69) rotate(70.89)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 2077.81,
    y1: 590.38,
    x2: 1771.98,
    y2: 1052.4,
    gradientTransform: "translate(1460.81 -1380.76) rotate(56.27)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 2068.68,
    y1: 603.62,
    x2: 1905.84,
    y2: 877.01,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 2043.06,
    y1: 660.21,
    x2: 2118.84,
    y2: 572.25,
    gradientTransform: "translate(2481.49 -1595.4) rotate(84.41)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 2161.66,
    y1: 508.1,
    x2: 1937.58,
    y2: 846.62,
    gradientTransform: "translate(1502.46 -1536.56) rotate(58.6)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 2154.98,
    y1: 517.8,
    x2: 2035.66,
    y2: 718.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 369.86,
    y1: 285.98,
    x2: 729.07,
    y2: 285.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 549.47,
    cy: 285.98,
    r: 179.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 605.02,
    y1: 276.07,
    x2: 301.02,
    y2: 920.07,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 556.05,
    y1: 227.28,
    x2: 527.32,
    y2: 685.13,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 605,
    y1: 384.72,
    x2: 603.85,
    y2: 402.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 506.48,
    y1: 396.6,
    x2: 517.68,
    y2: 396.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 531.29,
    y1: 410.73,
    x2: 554.42,
    y2: 410.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 470.01,
    y1: 382.23,
    x2: 492.87,
    y2: 382.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 463.59,
    y1: 375.45,
    x2: 558.94,
    y2: 375.45,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 96.75,
    y1: 660.11,
    x2: 404.93,
    y2: 660.11,
    gradientTransform: "translate(540.24 15.97) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 256.87,
    y1: 428.22,
    x2: 291.99,
    y2: 496.56,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 220.02,
    y1: 605.57,
    x2: 308.23,
    y2: 605.57,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 203.58,
    y1: 519.69,
    x2: 309.22,
    y2: 519.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 235.77,
    y1: 563.09,
    x2: 253.53,
    y2: 563.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 274.87,
    y1: 563.92,
    x2: 293.51,
    y2: 563.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 218.84,
    y1: 733.75,
    x2: 251.25,
    y2: 696.13,
    gradientTransform: "translate(746.13 145.16) rotate(61.85)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 269.56,
    y1: 668.7,
    x2: 173.73,
    y2: 813.47,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 266.7,
    y1: 672.84,
    x2: 215.68,
    y2: 758.51,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 263.12,
    y1: 733.52,
    x2: 319.54,
    y2: 668.04,
    gradientTransform: "translate(565.37 -31.48) rotate(45)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 351.42,
    y1: 620.28,
    x2: 184.59,
    y2: 872.3,
    gradientTransform: "translate(895.89 201.44) rotate(76.72)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 346.44,
    y1: 627.5,
    x2: 257.61,
    y2: 776.63,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 290.46,
    y1: 829.41,
    x2: 348.51,
    y2: 762.02,
    gradientTransform: "translate(918.63 146.5) rotate(67.5)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 381.32,
    y1: 712.88,
    x2: 209.66,
    y2: 972.21,
    gradientTransform: "translate(976.38 205.55) rotate(73.15)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 376.2,
    y1: 720.31,
    x2: 284.79,
    y2: 873.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 361.81,
    y1: 752.07,
    x2: 404.35,
    y2: 702.71,
    gradientTransform: "translate(995.05 146.12) rotate(76.72)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 428.38,
    y1: 666.7,
    x2: 302.61,
    y2: 856.7,
    gradientTransform: "translate(789.09 -11.89) rotate(58.28)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 424.63,
    y1: 672.14,
    x2: 357.66,
    y2: 784.58,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 206.11,
    y1: 1195.4,
    x2: 558.05,
    y2: 1195.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 366.91,
    y1: 1462.26,
    x2: 370.01,
    y2: 1380.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 423.17,
    y1: 1464.4,
    x2: 426.27,
    y2: 1382.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 396.65,
    y1: 959.84,
    x2: 375.93,
    y2: 1254,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 379.32,
    y1: 946.66,
    x2: 381.32,
    y2: 1035.66,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 415.22,
    y1: 869.44,
    x2: 373.89,
    y2: 956.77,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 437.28,
    y1: 879.88,
    x2: 395.94,
    y2: 967.21,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 396.06,
    y1: 860.37,
    x2: 354.72,
    y2: 947.7,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 385.56,
    y1: 1194,
    x2: 393.73,
    y2: 1450.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 381.59,
    y1: 1137.46,
    x2: 400.18,
    y2: 1137.46,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 415.68,
    y1: 1078.14,
    x2: 374.35,
    y2: 1158.8,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 243.85,
    y1: 1253.23,
    x2: 297.2,
    y2: 1191.31,
    gradientTransform: "translate(1153.79 310.68) rotate(58.28)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 327.34,
    y1: 1146.15,
    x2: 169.6,
    y2: 1384.45,
    gradientTransform: "translate(478.12 -23.56) rotate(22.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 322.64,
    y1: 1152.98,
    x2: 238.64,
    y2: 1293.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 110.98,
    y1: 1341.24,
    x2: 189.32,
    y2: 1250.31,
    gradientTransform: "translate(938.72 230.68) rotate(45)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 233.59,
    y1: 1183.98,
    x2: 1.92,
    y2: 1533.97,
    gradientTransform: "translate(1271.28 594.33) rotate(67.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 226.68,
    y1: 1194.01,
    x2: 103.32,
    y2: 1401.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 219.2,
    y1: 1488.96,
    x2: 314.75,
    y2: 1378.05,
    gradientTransform: "translate(1582.93 751.5) rotate(76.72)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 368.75,
    y1: 1297.15,
    x2: 86.19,
    y2: 1724.02,
    gradientTransform: "translate(1320.52 383.11) rotate(58.28)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 360.32,
    y1: 1309.38,
    x2: 209.86,
    y2: 1561.98,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 336.65,
    y1: 1361.67,
    x2: 406.66,
    y2: 1280.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 446.23,
    y1: 1221.13,
    x2: 239.19,
    y2: 1533.9,
    gradientTransform: "translate(1342.98 315.58) rotate(61.85)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 440.05,
    y1: 1230.09,
    x2: 329.81,
    y2: 1415.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 1055.07,
    y1: 193.65,
    x2: 935.07,
    y2: 757.65,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 1146.61,
    y1: 213.13,
    x2: 1026.61,
    y2: 777.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 1223.43,
    y1: 229.47,
    x2: 1103.43,
    y2: 793.47,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 1314.6,
    y1: 248.87,
    x2: 1194.6,
    y2: 812.87,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2082.74,793c-36.88-38.2-80.49-75.47-91.86-127.34-19.68-89.77,64.46-166.31,92-254,19.05-60.62,9.22-129.64-26-182.54s-95.08-88.58-158.34-94.39c-108.86-10-215.38,63.38-322.61,42.13-85.86-17-153.7-92.06-240.86-100.1-102.56-9.46-187.65,75.22-285.59,107.1-117.14,38.14-244.14-1.72-359.31-45.45S453.84,45.93,332.44,66.86C197.31,90.16,84,207.94,65.93,343.9,48,478.64,198.24,586.81,70.37,748.6c-40,50.56-66.54,120.95-48.88,182.94,17.17,60.22,90.21,98.31,90.74,160.93.42,49.43-46.18,88.77-49.93,138.06C59.07,1272.84,89.5,1312,126.88,1332s536.75,57.7,750,53.44l1009-20.17c34.56-.69,70-1.54,102.17-14.11s61.1-39.48,66-73.71c8.35-58.26-52.53-108.81-46.9-167.4,7.18-74.8,112.49-103.66,132.53-176.08C2153.81,882.79,2119.61,831.24,2082.74,793Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1285.25,1351.46s276.43-533.61,654.59-763c25.42-15.42,61.62,3,63.74,32.55C2017.77,818.51,1999.79,1401.06,1285.25,1351.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1356.1,1331.45c-1.84,1-.29,3.67,1.69,3,73.07-25.88,365.6-171.09,550-568.69.59-1.28-1.48-2.39-2.19-1.17C1853.05,854.06,1646.89,1180.72,1356.1,1331.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1044.77,1345.54s-68.16-597.09,117.78-998.4c12.5-27,52.83-31.87,71.06-8.54C1355.55,494.63,1665.52,988.19,1044.77,1345.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1092.42,1289.41c-1,1.82,1.8,3.21,3.06,1.52,46.21-62.23,208-345.91,139.35-778.77-.22-1.4-2.56-1.16-2.47.24C1238.65,616,1249.72,1002.12,1092.42,1289.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1106.17,1374.88s171.13-670.5,518-1029.95c23.31-24.16,65.63-13.57,74.52,18.76C1758.16,579.88,1870.45,1233.93,1106.17,1374.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1176.33,1333.12c-1.72,1.57.52,4.17,2.45,2.85,71.19-48.9,346.78-291,451.57-784.71a1.34,1.34,0,0,0-2.57-.7C1592.55,664.72,1448.86,1085.32,1176.33,1333.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M201.9,874.54a3.46,3.46,0,0,1,.94-6.68c58.71-4.57,274.54-8.38,467.74,155.26,176.78,149.73,276.27,283.73,311.27,335.08A16.07,16.07,0,0,1,970,1383.26c-72.56,6.28-276.64,13.23-382.36-92.29C461.27,1164.88,366.2,937.82,201.9,874.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M389.64,942.74s200.6,35.53,577.56,420C967.2,1362.76,567.89,996.42,389.64,942.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1161.24,1371.93S1046.67,652.54,717.8,242.22c-22.11-27.58-67.48-20.56-79.93,12.47C554.65,475.56,373.71,1150.3,1161.24,1371.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1091.73,1321.38c1.65,1.81-1,4.32-2.85,2.75C1019,1266,753.5,985.53,691.38,457.91a1.41,1.41,0,0,1,2.77-.48C720,580.5,830,1035.28,1091.73,1321.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1647.84,
    cy: 264.84,
    r: 202.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1648.24,
    cy: 267.04,
    r: 183.22,
    transform: "translate(293.94 1243.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1843.7,314.38H1608a18.53,18.53,0,0,1-18.44-16.78L1574.71,140a18.52,18.52,0,0,1,18.08-20.26L1843.35,115a18.52,18.52,0,0,1,18.87,18.52V295.86A18.52,18.52,0,0,1,1843.7,314.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1589.77,154l10.54,136.28a11.44,11.44,0,0,0,11.3,10.57l226.21,2.37a11.45,11.45,0,0,0,11.58-11.45V145.09a11.46,11.46,0,0,0-11.85-11.45l-236.75,8.07A11.46,11.46,0,0,0,1589.77,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1710.54,152.8,1838.11,149a2.32,2.32,0,0,1,2.39,2.32v2a2.32,2.32,0,0,1-2.29,2.32l-127.57,1.77a2.33,2.33,0,0,1-2.35-2.32h0A2.31,2.31,0,0,1,1710.54,152.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1708.29,
    y: 163.49,
    width: 132.21,
    height: 5.51,
    rx: 2.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1677.14,280.53a1.05,1.05,0,0,1-1.05-1v-3.12a1,1,0,0,1,1-1.05h0a1,1,0,0,1,1,1v3.12a1.05,1.05,0,0,1-1,1Zm0-10.41a1,1,0,0,1-1-1V266a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1v3.13a1,1,0,0,1-1,1Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1v3.12a1,1,0,0,1-1,1Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1v3.12a1,1,0,0,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1729.41,277.56a1,1,0,0,1-1-1V273.4a1,1,0,0,1,2.08,0v3.12A1,1,0,0,1,1729.41,277.56Zm0-10.41a1,1,0,0,1-1-1V263a1,1,0,0,1,2.08,0v3.12A1,1,0,0,1,1729.41,267.15Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,0,1,2.08,0v3.12A1,1,0,0,1,1729.41,256.74Zm0-10.4a1,1,0,0,1-1-1v-3.13a1,1,0,0,1,2.08,0v3.13A1,1,0,0,1,1729.41,246.34Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1729.41,235.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1769.28,286.16a1,1,0,0,1-1-1l-.06-1.86a1,1,0,0,1,1-1.07,1,1,0,0,1,1.07,1l.06,1.87a1,1,0,0,1-1,1.07ZM1769,277a1,1,0,0,1-1-1l-.1-3.12a1,1,0,1,1,2.08-.07l.1,3.12a1.06,1.06,0,0,1-1,1.08Zm-.33-10.41a1,1,0,0,1-1-1l-.09-3.12a1,1,0,0,1,1-1.07,1,1,0,0,1,1.08,1l.09,3.12a1,1,0,0,1-1,1.07Zm-.32-10.4a1,1,0,0,1-1-1l-.1-3.12a1,1,0,0,1,1-1.07,1,1,0,0,1,1.07,1l.1,3.12a1,1,0,0,1-1,1.07Zm-.32-10.4a1,1,0,0,1-1-1l-.1-3.12a1,1,0,0,1,1-1.07,1,1,0,0,1,1.07,1l.1,3.12a1.06,1.06,0,0,1-1,1.08Zm-.33-10.41a1,1,0,0,1-1-1l-.09-3.12a1,1,0,1,1,2.08-.07l.09,3.12a1,1,0,0,1-1,1.07Zm-.32-10.4a1,1,0,0,1-1-1l-.1-3.12a1.05,1.05,0,0,1,1-1.07,1,1,0,0,1,1.07,1l.1,3.12a1,1,0,0,1-1,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1807.18,280.34a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1807.18,280.34Zm0-10.41a1,1,0,0,1-1-1v-3.13a1,1,0,0,1,2.08,0v3.13A1,1,0,0,1,1807.18,269.93Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1807.18,259.52Zm0-10.41a1,1,0,0,1-1-1V245a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1807.18,249.11Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1807.18,238.7Zm0-10.4a1,1,0,0,1-1-1v-3.13a1,1,0,0,1,2.08,0v3.13A1,1,0,0,1,1807.18,228.3Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1807.18,217.89Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0v3.12A1,1,0,0,1,1807.18,207.48Zm0-10.41a1,1,0,0,1-1-1v-3.12a1,1,0,1,1,2.08,0V196A1,1,0,0,1,1807.18,197.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1621.18,292.62a1.55,1.55,0,0,1-1.55-1.43l-10.67-126a1.55,1.55,0,0,1,1.42-1.69,1.57,1.57,0,0,1,1.69,1.43l10.67,126a1.57,1.57,0,0,1-1.43,1.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1605.76 171.7 1610.59 165.98 1616.31 170.81 1615.93 166.33 1610.21 161.5 1605.38 167.22 1605.76 171.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1832.63,286.68H1613.09a1.56,1.56,0,1,1,0-3.12h219.54a1.56,1.56,0,0,1,0,3.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1826.41 290.41 1831.71 285.12 1826.41 279.83 1830.91 279.83 1836.2 285.12 1830.91 290.41 1826.41 290.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1630.31,250.48a1.56,1.56,0,0,1-.2-3.11c1.15-.16,116.1-15.9,179-62.29a1.55,1.55,0,0,1,2.18.32,1.57,1.57,0,0,1-.33,2.19c-63.58,46.88-179.31,62.72-180.47,62.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1810.55,194.64h-.13A1.56,1.56,0,0,1,1809,193l.48-6.13-8.65-.51a1.56,1.56,0,0,1-1.46-1.65,1.54,1.54,0,0,1,1.65-1.47l10.23.61a1.54,1.54,0,0,1,1.09.53,1.61,1.61,0,0,1,.38,1.15l-.61,7.72A1.57,1.57,0,0,1,1810.55,194.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1483.45,321.31l2.87,89.42a29.09,29.09,0,0,0,29,28.09l214.13,1.26a21,21,0,0,0,20.93-17.86c3.34-22.58,7.61-63,2.81-100.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1721.83,434.59h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,0,.52Zm3.64,0a.25.25,0,0,1-.26-.24.27.27,0,0,1,.25-.28c.5,0,1-.08,1.53-.15a.26.26,0,0,1,.29.22.27.27,0,0,1-.22.3c-.52.07-1,.12-1.57.15Zm-8.84,0h-1.56a.26.26,0,0,1,0-.52h1.57a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.24.24,0,0,1,.25.26A.26.26,0,0,1,1711.43,434.53Zm-5.19,0h-1.57a.26.26,0,0,1-.25-.26.27.27,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.27.27,0,0,1,1706.24,434.5Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.25.25,0,0,1,.26-.26H1701a.26.26,0,0,1,.26.26A.26.26,0,0,1,1701,434.47Zm-5.2,0h-1.56a.26.26,0,1,1,0-.52h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1695.84,434.44Zm-5.2,0h-1.56a.27.27,0,0,1-.26-.27.26.26,0,0,1,.26-.25h1.56a.27.27,0,0,1,.26.27A.26.26,0,0,1,1690.64,434.4Zm-5.2,0h-1.56a.25.25,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.27.27,0,0,1,.26.27A.26.26,0,0,1,1685.44,434.37Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26H1675a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.25.25,0,0,1,1669.84,434.28Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.25.25,0,0,1,1664.64,434.25Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.27.27,0,0,1,.26-.26h1.57a.26.26,0,0,1,.25.26A.25.25,0,0,1,1659.44,434.22Zm-5.19,0h-1.57a.25.25,0,0,1-.25-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.27.27,0,0,1,1654.25,434.19Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,1,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.29.29,0,0,1,.26-.26h1.56a.26.26,0,1,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,1,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.25.25,0,0,1,.26.26A.26.26,0,0,1,1628.25,434Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.25.25,0,0,1,.26.26A.26.26,0,0,1,1623.05,434Zm-5.2,0h-1.56a.27.27,0,0,1-.26-.27.26.26,0,0,1,.26-.25h1.56a.25.25,0,0,1,.26.26A.26.26,0,0,1,1617.85,434Zm-5.2,0h-1.56a.27.27,0,0,1-.26-.27.26.26,0,0,1,.26-.25h1.56a.26.26,0,1,1,0,.51Zm-5.2,0h-1.56a.27.27,0,0,1-.26-.27.26.26,0,0,1,.26-.25h1.56a.27.27,0,0,1,.26.27A.25.25,0,0,1,1607.45,433.91Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.27.27,0,0,1,.26-.26h1.57a.25.25,0,0,1,.25.27A.25.25,0,0,1,1602.25,433.88Zm-5.19,0h-1.57a.25.25,0,0,1-.25-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,1,1,0,.52Zm-5.2,0h-1.56a.25.25,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1591.86,433.82Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1586.66,433.79Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1581.46,433.76Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1576.26,433.73Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.29.29,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1571.06,433.7Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1565.86,433.67Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,1,1,0,.52Zm175.1,0a.27.27,0,0,1-.25-.18.27.27,0,0,1,.17-.33c.48-.16,1-.34,1.44-.54a.27.27,0,0,1,.34.14.26.26,0,0,1-.14.34c-.48.2-1,.39-1.48.56Zm-180.3,0h-1.56a.26.26,0,1,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.24.24,0,0,1,.25.26A.26.26,0,0,1,1545.06,433.55Zm-5.19,0h-1.57a.26.26,0,0,1-.25-.26.25.25,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26A.27.27,0,0,1,1539.87,433.52Zm-5.2,0h-1.56a.26.26,0,0,1-.26-.27.25.25,0,0,1,.26-.25h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1534.67,433.49Zm-5.2,0h-1.56a.27.27,0,0,1-.26-.27.25.25,0,0,1,.26-.25h1.56a.27.27,0,0,1,.26.27A.26.26,0,0,1,1529.47,433.45Zm-5.2,0h-1.56a.25.25,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.27.27,0,0,1,.26.27A.26.26,0,0,1,1524.27,433.42Zm-5.2-.05h0c-.52,0-1-.07-1.57-.13a.25.25,0,0,1-.23-.28.24.24,0,0,1,.28-.23c.51,0,1,.09,1.54.12a.25.25,0,0,1,.25.27A.26.26,0,0,1,1519.07,433.37Zm-5.14-.74h-.06c-.51-.12-1-.26-1.52-.41a.27.27,0,0,1-.17-.33.26.26,0,0,1,.32-.17c.49.15,1,.28,1.49.4a.28.28,0,0,1,.2.32A.27.27,0,0,1,1513.93,432.63Zm221.3-1.31a.25.25,0,0,1-.22-.12.26.26,0,0,1,.07-.36c.43-.28.86-.58,1.26-.89a.25.25,0,0,1,.36.05.26.26,0,0,1,0,.36c-.42.32-.85.63-1.29.92A.23.23,0,0,1,1735.23,431.32ZM1509,430.94l-.1,0c-.48-.22-1-.45-1.42-.69a.27.27,0,0,1-.11-.35.26.26,0,0,1,.35-.11c.46.24.93.46,1.39.67a.26.26,0,0,1-.11.5Zm-4.5-2.57a.26.26,0,0,1-.15,0c-.43-.3-.85-.62-1.26-.94a.26.26,0,0,1,0-.37.27.27,0,0,1,.37,0c.4.32.82.63,1.24.92a.27.27,0,0,1,.06.36A.26.26,0,0,1,1504.52,428.37Zm234.64-.43a.27.27,0,0,1-.17-.06.26.26,0,0,1,0-.37c.34-.38.67-.78,1-1.18a.26.26,0,0,1,.41.31c-.32.42-.66.83-1,1.22A.27.27,0,0,1,1739.16,427.94ZM1500.57,425a.27.27,0,0,1-.19-.08c-.36-.37-.72-.76-1.07-1.16a.26.26,0,0,1,.4-.34c.33.39.68.77,1,1.14a.27.27,0,0,1,0,.37A.26.26,0,0,1,1500.57,425Zm241.52-1.34a.27.27,0,0,1-.12,0,.25.25,0,0,1-.11-.35c.23-.46.44-.93.64-1.4a.26.26,0,0,1,.34-.14.27.27,0,0,1,.14.34q-.3.74-.66,1.44A.27.27,0,0,1,1742.09,423.67ZM1497.31,421a.25.25,0,0,1-.22-.12c-.29-.43-.57-.88-.83-1.33a.26.26,0,0,1,.09-.36.27.27,0,0,1,.36.1c.25.44.53.88.81,1.31a.26.26,0,0,1-.07.36A.25.25,0,0,1,1497.31,421Zm246.5-2.19h-.06a.25.25,0,0,1-.2-.3q.12-.59.21-1.17l0-.36a.25.25,0,0,1,.3-.21.26.26,0,0,1,.22.29l-.06.36c-.06.4-.13.8-.21,1.19A.27.27,0,0,1,1743.81,418.78Zm-249-2.39a.26.26,0,0,1-.24-.16c-.2-.48-.39-1-.57-1.47a.26.26,0,0,1,.16-.33.25.25,0,0,1,.33.16c.17.48.36,1,.56,1.44a.27.27,0,0,1-.14.34Zm249.73-2.75h0a.26.26,0,0,1-.22-.3c.07-.5.14-1,.21-1.54a.26.26,0,0,1,.29-.22.25.25,0,0,1,.23.29c-.07.52-.15,1-.22,1.54A.26.26,0,0,1,1744.59,413.64Zm-251.27-2.21a.28.28,0,0,1-.26-.21c-.1-.51-.2-1-.27-1.55a.24.24,0,0,1,.21-.29.26.26,0,0,1,.3.22c.08.5.17,1,.27,1.52a.25.25,0,0,1-.2.3Zm252-2.95h0a.26.26,0,0,1-.22-.29l.19-1.55a.26.26,0,0,1,.29-.22.27.27,0,0,1,.23.29l-.2,1.55A.26.26,0,0,1,1745.27,408.48Zm-252.53-2.21a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,1,1,.52,0l0,1.56a.26.26,0,0,1-.25.27Zm253.16-2.95h0a.27.27,0,0,1-.23-.29l.18-1.55a.26.26,0,1,1,.52.06l-.18,1.55A.27.27,0,0,1,1745.9,403.32Zm-253.33-2.25a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,0,1,.25-.26.25.25,0,0,1,.27.25l0,1.56a.25.25,0,0,1-.25.26Zm253.9-2.92h0a.26.26,0,0,1-.23-.28c0-.52.11-1,.16-1.56a.26.26,0,0,1,.28-.23.27.27,0,0,1,.24.29c-.06.52-.11,1-.16,1.55A.27.27,0,0,1,1746.47,398.15Zm-254.07-2.27a.26.26,0,0,1-.26-.25l-.05-1.56a.26.26,0,0,1,.26-.27.26.26,0,0,1,.26.25l.05,1.56a.26.26,0,0,1-.25.27ZM1747,393h0a.27.27,0,0,1-.23-.29c0-.51.09-1,.14-1.55a.26.26,0,0,1,.52.05c-.05.52-.09,1-.14,1.55A.26.26,0,0,1,1747,393Zm-254.74-2.3a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,0,1,.25-.27.27.27,0,0,1,.27.25l0,1.56a.26.26,0,0,1-.25.27Zm255.19-2.88h0a.26.26,0,0,1-.24-.28l.12-1.56a.26.26,0,0,1,.28-.24.27.27,0,0,1,.24.28l-.12,1.56A.27.27,0,0,1,1747.43,387.8Zm-255.36-2.31a.26.26,0,0,1-.26-.26l0-1.56a.25.25,0,0,1,.25-.26.26.26,0,0,1,.27.25l0,1.56a.27.27,0,0,1-.25.27Zm255.75-2.88h0a.25.25,0,0,1-.24-.28l.1-1.55a.25.25,0,0,1,.28-.24.25.25,0,0,1,.24.27l-.11,1.56A.25.25,0,0,1,1747.82,382.61Zm-255.92-2.32a.26.26,0,0,1-.26-.25l-.05-1.56a.27.27,0,0,1,.25-.27.25.25,0,0,1,.27.25l.05,1.56a.26.26,0,0,1-.25.27Zm256.24-2.87h0a.26.26,0,0,1-.24-.27c0-.52.06-1,.08-1.56a.27.27,0,0,1,.28-.25.26.26,0,0,1,.24.28c0,.52,0,1-.08,1.56A.26.26,0,0,1,1748.14,377.42Zm-256.4-2.33a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,0,1,.25-.27.27.27,0,0,1,.27.26l0,1.55a.26.26,0,0,1-.26.27Zm256.66-2.86h0a.26.26,0,0,1-.24-.27l.06-1.56a.26.26,0,1,1,.52,0l-.06,1.56A.27.27,0,0,1,1748.4,372.23Zm-256.83-2.33a.26.26,0,0,1-.26-.26l0-1.55a.25.25,0,0,1,.25-.27.26.26,0,0,1,.27.25l0,1.56a.27.27,0,0,1-.25.27Zm257-2.87h0a.26.26,0,0,1-.26-.27c0-.52,0-1,0-1.56a.26.26,0,0,1,.26-.25.27.27,0,0,1,.26.27c0,.52,0,1-.05,1.56A.26.26,0,0,1,1748.58,367ZM1491.4,364.7a.26.26,0,0,1-.26-.25l-.05-1.56a.27.27,0,0,1,.25-.27.26.26,0,0,1,.27.25l.05,1.56a.26.26,0,0,1-.25.27Zm257.3-2.87h0a.26.26,0,0,1-.26-.26c0-.52,0-1,0-1.56a.29.29,0,0,1,.26-.26.26.26,0,0,1,.26.27c0,.52,0,1,0,1.56A.26.26,0,0,1,1748.7,361.83Zm-257.47-2.33a.26.26,0,0,1-.26-.25l0-1.56a.27.27,0,0,1,.26-.27.26.26,0,0,1,.26.26l0,1.55a.25.25,0,0,1-.25.27Zm257.51-2.87a.26.26,0,0,1-.26-.26v-1.55a.27.27,0,0,1,.26-.27h0a.26.26,0,0,1,.26.26v1.56A.26.26,0,0,1,1748.74,356.63Zm-257.67-2.32a.26.26,0,0,1-.26-.25l0-1.56a.25.25,0,0,1,.25-.27.26.26,0,0,1,.27.25l0,1.56a.27.27,0,0,1-.25.27Zm257.63-2.87a.26.26,0,0,1-.26-.26c0-.52,0-1,0-1.56a.26.26,0,0,1,.52,0c0,.52,0,1,0,1.56a.27.27,0,0,1-.25.27Zm-257.8-2.33a.26.26,0,0,1-.26-.25l-.05-1.56a.27.27,0,0,1,.25-.27.26.26,0,0,1,.27.25l.05,1.56a.26.26,0,0,1-.25.27Zm257.68-2.87a.26.26,0,0,1-.26-.25c0-.52,0-1,0-1.56a.26.26,0,0,1,.25-.27.26.26,0,0,1,.27.25c0,.52,0,1,0,1.56a.27.27,0,0,1-.25.27Zm-257.85-2.33a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,0,1,.25-.26.25.25,0,0,1,.27.25l0,1.56a.25.25,0,0,1-.25.26Zm257.64-2.86a.26.26,0,0,1-.26-.25c0-.52,0-1-.08-1.56a.26.26,0,0,1,.52,0c0,.52,0,1,.08,1.56a.26.26,0,0,1-.25.28Zm-257.8-2.33a.26.26,0,0,1-.26-.25l0-1.56a.25.25,0,0,1,.25-.27.27.27,0,0,1,.27.25l0,1.56a.27.27,0,0,1-.26.27Zm257.5-2.86a.26.26,0,0,1-.26-.25c0-.52-.07-1-.11-1.55a.26.26,0,0,1,.52,0c0,.52.07,1,.11,1.56a.26.26,0,0,1-.25.27Zm-257.67-2.34a.26.26,0,0,1-.26-.25l-.05-1.56a.26.26,0,0,1,.52,0l.05,1.56a.26.26,0,0,1-.25.27Zm257.26-2.85a.25.25,0,0,1-.25-.23l-.15-1.56a.27.27,0,0,1,.24-.28.26.26,0,0,1,.28.23c0,.52.1,1,.14,1.56a.25.25,0,0,1-.23.28Zm-257.43-2.35a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,0,1,.52,0l0,1.56a.25.25,0,0,1-.25.26Zm256.92-2.82a.25.25,0,0,1-.25-.23l-.18-1.55a.27.27,0,0,1,.23-.29.25.25,0,0,1,.29.23c.06.51.12,1,.17,1.55a.26.26,0,0,1-.23.29Zm-257.09-2.37a.26.26,0,0,1-.26-.25l0-1.83h.94a.26.26,0,0,1,0,.52h-.41l0,1.29a.26.26,0,0,1-.25.27Zm255.39-1.56h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.55a.26.26,0,0,1,0-.52h1.55a.26.26,0,0,1,0,.52Zm-5.19,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.19,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.19,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.19,0h-1.56a.26.26,0,1,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1546.2,256.4l.64-6.9a5.32,5.32,0,0,1,4-3.1c6.68-1.06,23.22-2.92,31.19,3l1.19,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1567,249.76a9.75,9.75,0,0,1-4.62,0,4.18,4.18,0,0,1-3.18-4v-21.6h11V245.7A4.19,4.19,0,0,1,1567,249.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1652.64,256.4l.64-6.9a5.32,5.32,0,0,1,4-3.1c6.67-1.06,23.22-2.92,31.18,3l1.19,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1673.48,249.76a9.75,9.75,0,0,1-4.62,0,4.18,4.18,0,0,1-3.18-4V221.85h11V245.7A4.19,4.19,0,0,1,1673.48,249.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1558.12,229.42l118.19-3.92a5.69,5.69,0,0,0,5.44-4.67,48.1,48.1,0,0,0,.37-15,13.64,13.64,0,0,0-13.22-11.54c-22-.53-78.17-.51-109.1,11.73a10.81,10.81,0,0,0-6.53,7.49,26.23,26.23,0,0,0-.28,12A5.09,5.09,0,0,0,1558.12,229.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1556.08,223.27a.52.52,0,0,1-.52-.46,27.65,27.65,0,0,1,.71-8.91,9.86,9.86,0,0,1,6.71-6.82c6.58-1.93,19.16-5.22,29.44-5.51a.53.53,0,0,1,.54.51.51.51,0,0,1-.51.53c-10.16.29-22.64,3.55-29.18,5.47a8.81,8.81,0,0,0-6,6.09,27.06,27.06,0,0,0-.67,8.53.53.53,0,0,1-.47.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1491.37,253.71c38.18-.49,203.35-2.22,251.32,3.56a9.77,9.77,0,0,1,8.4,7.57c2.83,12.82,8.54,42.59,7.86,72.1a8.54,8.54,0,0,1-7,8.16l-109.52,20.72h-38.9l-116.69-23.2a9.12,9.12,0,0,1-7.36-8.47c-.76-14.85-1.94-49.69,2.07-72.11A10.09,10.09,0,0,1,1491.37,253.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1641.53,356.64H1640a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.55a.26.26,0,1,1,0-.52h1.55a.26.26,0,0,1,0,.52Zm-5.19,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0H1614a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm-5.2,0h-.68l-1.58-.31a.27.27,0,0,1-.21-.31.26.26,0,0,1,.31-.2l1.53.3h.63a.26.26,0,0,1,0,.52Zm40-.67a.27.27,0,0,1-.26-.22.27.27,0,0,1,.21-.3l1.53-.29a.27.27,0,0,1,.31.21.26.26,0,0,1-.21.3l-1.53.29Zm-45.75-.34h0l-1.53-.3a.28.28,0,0,1-.21-.31.26.26,0,0,1,.31-.2l1.53.3a.26.26,0,0,1,.2.31A.26.26,0,0,1,1599.36,355.63Zm50.86-.63a.27.27,0,0,1-.26-.21.28.28,0,0,1,.21-.31l1.53-.29a.26.26,0,0,1,.1.52l-1.53.29Zm-56-.39h0l-1.53-.31a.25.25,0,0,1-.2-.3.25.25,0,0,1,.3-.21l1.53.31a.25.25,0,0,1,.2.3A.25.25,0,0,1,1594.26,354.61Zm61.07-.58a.25.25,0,0,1-.26-.21.25.25,0,0,1,.21-.3l1.53-.29a.25.25,0,0,1,.3.21.25.25,0,0,1-.2.3l-1.54.29Zm-66.17-.43h-.05l-1.53-.3a.26.26,0,0,1-.2-.31.25.25,0,0,1,.3-.2l1.53.3a.26.26,0,0,1,0,.52Zm71.27-.53a.26.26,0,0,1-.25-.22.25.25,0,0,1,.21-.3l1.53-.29a.26.26,0,0,1,.3.21.25.25,0,0,1-.21.3l-1.53.29Zm-76.37-.48h0l-1.53-.3a.26.26,0,0,1-.2-.31.25.25,0,0,1,.3-.2l1.53.3a.26.26,0,0,1,0,.52Zm81.48-.49a.26.26,0,0,1-.25-.21.26.26,0,0,1,.2-.31l1.54-.28a.25.25,0,0,1,.3.2.27.27,0,0,1-.21.31l-1.53.29Zm-86.58-.53h0l-1.53-.31a.25.25,0,0,1-.2-.3.26.26,0,0,1,.3-.21l1.53.31a.25.25,0,0,1,.21.3A.27.27,0,0,1,1579,351.57Zm91.69-.44a.25.25,0,0,1-.25-.21.25.25,0,0,1,.2-.3l1.54-.29a.25.25,0,0,1,.3.21.26.26,0,0,1-.21.3l-1.53.29Zm-96.79-.57h0l-1.53-.3a.26.26,0,0,1-.2-.31.25.25,0,0,1,.3-.2l1.53.3a.27.27,0,0,1,.21.31A.28.28,0,0,1,1573.86,350.56Zm101.9-.39a.28.28,0,0,1-.26-.21.27.27,0,0,1,.21-.31l1.53-.29a.27.27,0,0,1,.31.21.26.26,0,0,1-.21.3l-1.53.29Zm-107-.63h0l-1.53-.3a.26.26,0,0,1-.2-.31.25.25,0,0,1,.3-.2l1.53.3a.26.26,0,0,1,.21.31A.26.26,0,0,1,1568.76,349.54Zm112.11-.34a.28.28,0,0,1-.26-.21.26.26,0,0,1,.21-.3l1.53-.29a.26.26,0,0,1,.31.2.28.28,0,0,1-.21.31l-1.53.29Zm-117.21-.67h-.05l-1.53-.31a.25.25,0,0,1-.2-.3.26.26,0,0,1,.3-.21l1.53.31a.25.25,0,0,1,.21.3A.26.26,0,0,1,1563.66,348.53Zm122.32-.3a.26.26,0,0,1,0-.51l1.53-.29a.26.26,0,0,1,.1.51l-1.53.29Zm-127.42-.71h0l-1.53-.3a.26.26,0,0,1-.2-.31.26.26,0,0,1,.31-.2l1.53.3a.26.26,0,0,1,.2.31A.27.27,0,0,1,1558.56,347.52Zm132.53-.25a.26.26,0,0,1-.26-.21.27.27,0,0,1,.21-.31l1.53-.29a.26.26,0,0,1,.3.21.25.25,0,0,1-.2.3l-1.54.29Zm-137.62-.77h-.06l-1.53-.31a.25.25,0,0,1-.2-.3.27.27,0,0,1,.31-.21l1.53.31a.25.25,0,0,1,.2.3A.25.25,0,0,1,1553.47,346.5Zm142.72-.2a.26.26,0,0,1-.25-.21.25.25,0,0,1,.21-.3l1.53-.29a.25.25,0,0,1,.3.2.26.26,0,0,1-.21.31l-1.53.29Zm-147.82-.81h-.06l-1.52-.3a.25.25,0,0,1-.21-.3.26.26,0,0,1,.31-.21l1.53.31a.25.25,0,0,1,.2.3A.26.26,0,0,1,1548.37,345.49Zm152.93-.15a.26.26,0,0,1-.25-.22.25.25,0,0,1,.2-.3l1.54-.29a.26.26,0,0,1,.09.51l-1.53.29Zm-158-.86h0l-1.53-.3a.27.27,0,0,1-.21-.31.26.26,0,0,1,.31-.2l1.53.3a.26.26,0,0,1,.2.31A.26.26,0,0,1,1543.27,344.48Zm163.14-.11a.26.26,0,0,1-.25-.21.26.26,0,0,1,.2-.31l1.54-.29a.27.27,0,0,1,.3.21.25.25,0,0,1-.21.3l-1.53.29Zm-168.24-.91h-.05l-1.53-.31a.25.25,0,0,1-.21-.3.27.27,0,0,1,.31-.21l1.53.31a.25.25,0,0,1,.2.3A.25.25,0,0,1,1538.17,343.46Zm173.35-.06a.27.27,0,0,1-.26-.21.26.26,0,0,1,.21-.3l1.53-.29a.26.26,0,0,1,.31.2.28.28,0,0,1-.21.31l-1.53.29Zm-178.45-.95h0l-1.53-.3a.26.26,0,1,1,.1-.51l1.53.3a.26.26,0,0,1,.2.31A.26.26,0,0,1,1533.07,342.45Zm183.56,0a.27.27,0,0,1-.26-.22.27.27,0,0,1,.21-.3l1.53-.29a.28.28,0,0,1,.31.21.27.27,0,0,1-.21.3l-1.53.29Zm5.11-1a.26.26,0,0,1-.26-.21.27.27,0,0,1,.21-.31l1.53-.29a.26.26,0,0,1,.3.21.25.25,0,0,1-.2.3l-1.54.29Zm-193.77,0h0l-1.53-.3a.28.28,0,0,1-.21-.31.26.26,0,0,1,.31-.2l1.53.3a.26.26,0,0,1,.2.31A.26.26,0,0,1,1528,341.44Zm198.87-.94a.25.25,0,0,1-.25-.21.25.25,0,0,1,.21-.3l1.53-.29a.25.25,0,0,1,.3.2.26.26,0,0,1-.2.31l-1.54.29Zm-204-.08h0l-1.53-.31a.26.26,0,1,1,.1-.51l1.53.31a.26.26,0,0,1-.05.51Zm209.08-.88a.26.26,0,0,1-.25-.22.25.25,0,0,1,.21-.3l1.53-.29a.26.26,0,0,1,.3.21.25.25,0,0,1-.21.3l-1.53.29Zm-214.18-.13h0l-1.53-.3a.28.28,0,0,1-.21-.31.26.26,0,0,1,.31-.2l1.53.3a.26.26,0,0,1,.2.31A.26.26,0,0,1,1517.77,339.41Zm219.29-.84a.26.26,0,0,1-.25-.21.26.26,0,0,1,.2-.31l1.54-.29a.26.26,0,0,1,.09.52l-1.53.29Zm-224.39-.18h-.05l-1.53-.3a.26.26,0,0,1-.2-.31.25.25,0,0,1,.3-.2l1.53.3a.25.25,0,0,1,.2.3A.25.25,0,0,1,1512.67,338.39Zm229.5-.79a.26.26,0,0,1-.05-.51l1.54-.29a.25.25,0,0,1,.3.2.26.26,0,0,1-.21.31l-1.53.29Zm-234.6-.22h0l-1.53-.31a.26.26,0,0,1,.1-.51l1.53.31a.26.26,0,0,1,.21.3A.27.27,0,0,1,1507.57,337.38Zm239.71-.74a.28.28,0,0,1-.26-.21.27.27,0,0,1,.21-.31l1.53-.29a.28.28,0,0,1,.31.21.26.26,0,0,1-.21.3l-1.53.29Zm-244.81-.27h0l-1.53-.3a.26.26,0,0,1-.2-.31.25.25,0,0,1,.3-.2l1.53.3a.26.26,0,0,1,0,.52Zm-5.1-1h0l-1.53-.31a.25.25,0,0,1-.2-.3.27.27,0,0,1,.3-.21l1.53.31a.26.26,0,0,1-.05.51Zm-5.1-1h0l-1.53-.3a.26.26,0,0,1,.1-.51l1.53.3a.27.27,0,0,1,.21.31A.28.28,0,0,1,1492.27,334.34Zm257.3-1h0a.26.26,0,0,1-.26-.26v-1.56a.25.25,0,0,1,.26-.26h0a.26.26,0,0,1,.26.26v1.56A.26.26,0,0,1,1749.57,333.31Zm-260.76-1.39a.26.26,0,0,1-.26-.25c0-.5,0-1-.08-1.56a.27.27,0,0,1,.25-.27.25.25,0,0,1,.27.25c0,.54,0,1.05.08,1.56a.27.27,0,0,1-.25.27Zm260.72-3.81a.26.26,0,0,1-.26-.26c0-.52,0-1,0-1.55a.26.26,0,0,1,.26-.27.24.24,0,0,1,.26.25c0,.52,0,1,0,1.56a.27.27,0,0,1-.26.27Zm-261-1.39a.26.26,0,0,1-.26-.25l-.06-1.56a.27.27,0,0,1,.25-.27.27.27,0,0,1,.27.25l.06,1.56a.25.25,0,0,1-.25.27Zm260.79-3.81a.26.26,0,0,1-.26-.25c0-.51,0-1-.07-1.55a.26.26,0,0,1,.25-.27.26.26,0,0,1,.27.25c0,.52,0,1,.07,1.55a.25.25,0,0,1-.25.27Zm-261-1.39a.26.26,0,0,1-.26-.25l0-1.56a.26.26,0,0,1,.25-.27.27.27,0,0,1,.27.26l0,1.56a.25.25,0,0,1-.25.26Zm260.7-3.8a.26.26,0,0,1-.26-.24c0-.52-.06-1-.1-1.56a.26.26,0,0,1,.52,0c0,.52.07,1,.1,1.56a.25.25,0,0,1-.24.27Zm-260.83-1.39a.26.26,0,0,1-.26-.26l0-1.56a.26.26,0,0,1,.25-.26.26.26,0,0,1,.27.25l0,1.56a.27.27,0,0,1-.26.27Zm260.46-3.79a.26.26,0,0,1-.25-.24c0-.52-.09-1-.13-1.56a.25.25,0,0,1,.23-.28.26.26,0,0,1,.28.24c.05.52.09,1,.13,1.56a.26.26,0,0,1-.23.28Zm-260.55-1.41a.26.26,0,0,1-.26-.26v-1.56a.25.25,0,0,1,.25-.26h0a.26.26,0,0,1,.26.25v1.56a.27.27,0,0,1-.25.27Zm260.09-3.77a.27.27,0,0,1-.26-.24l-.15-1.55a.27.27,0,0,1,.23-.29.27.27,0,0,1,.29.24l.15,1.55a.25.25,0,0,1-.23.28Zm-260.12-1.43a.26.26,0,0,1-.26-.26v-1.56a.25.25,0,0,1,.26-.26h0a.26.26,0,0,1,.26.26v1.56a.26.26,0,0,1-.26.26Zm259.57-3.75a.26.26,0,0,1-.26-.23c0-.52-.12-1-.18-1.55a.26.26,0,0,1,.23-.28.25.25,0,0,1,.29.22l.18,1.55a.25.25,0,0,1-.23.29Zm-259.56-1.45h0a.26.26,0,0,1-.26-.26c0-.52,0-1,0-1.56a.26.26,0,0,1,.26-.26h0a.26.26,0,0,1,.25.26c0,.52,0,1,0,1.56A.26.26,0,0,1,1488.16,300.73ZM1747.09,297a.27.27,0,0,1-.26-.23c-.07-.51-.13-1-.2-1.54a.26.26,0,0,1,.22-.29.25.25,0,0,1,.29.22l.21,1.55a.26.26,0,0,1-.23.29Zm-258.84-1.49h0a.25.25,0,0,1-.25-.26l0-1.56a.26.26,0,0,1,.27-.26.26.26,0,0,1,.25.27l0,1.56A.26.26,0,0,1,1488.25,295.53Zm258.13-3.66a.27.27,0,0,1-.26-.22c-.07-.52-.15-1-.23-1.55a.26.26,0,0,1,.52-.07c.07.51.15,1,.23,1.54a.27.27,0,0,1-.22.3Zm-258-1.54h0a.24.24,0,0,1-.25-.26c0-.53,0-1.05.06-1.57a.27.27,0,0,1,.27-.25.27.27,0,0,1,.25.27c0,.52,0,1-.07,1.56A.25.25,0,0,1,1488.4,290.33Zm257.19-3.6a.26.26,0,0,1-.26-.22c-.08-.52-.16-1-.25-1.54a.26.26,0,0,1,.52-.09c.08.51.16,1,.25,1.55a.26.26,0,0,1-.22.29Zm-257-1.59h0a.26.26,0,0,1-.24-.28c0-.52.05-1,.08-1.56a.26.26,0,0,1,.28-.24.25.25,0,0,1,.24.27c0,.52-.06,1-.08,1.56A.27.27,0,0,1,1488.63,285.14Zm256.1-3.54a.26.26,0,0,1-.26-.22q-.13-.78-.27-1.53a.26.26,0,1,1,.51-.1l.27,1.54a.25.25,0,0,1-.21.3ZM1489,279.94h0a.26.26,0,0,1-.24-.28l.12-1.55a.25.25,0,0,1,.28-.24.26.26,0,0,1,.24.28l-.12,1.55A.25.25,0,0,1,1489,279.94Zm254.84-3.46a.26.26,0,0,1-.25-.21q-.15-.78-.3-1.53a.27.27,0,0,1,.21-.31.26.26,0,0,1,.3.21q.15.75.3,1.53a.28.28,0,0,1-.21.31Zm-254.4-1.72h0a.26.26,0,0,1-.24-.28c0-.53.11-1,.16-1.56a.26.26,0,1,1,.52.06c0,.51-.11,1-.16,1.55A.25.25,0,0,1,1489.39,274.76Zm253.39-3.38a.26.26,0,0,1-.25-.21c-.11-.53-.22-1-.32-1.53a.26.26,0,0,1,.51-.11c.1.49.21,1,.32,1.53a.28.28,0,0,1-.21.31ZM1490,269.59h0a.26.26,0,0,1-.22-.29l.21-1.55a.26.26,0,0,1,.3-.22.26.26,0,0,1,.22.29c-.08.51-.15,1-.21,1.55A.26.26,0,0,1,1490,269.59Zm251.13-2.74h0l-1.55-.18a.26.26,0,0,1-.23-.28.27.27,0,0,1,.29-.24l1.55.18a.26.26,0,0,1,0,.52Zm-5.17-.54h0l-1.55-.14a.26.26,0,0,1,0-.52l1.56.14a.26.26,0,0,1,.23.28A.26.26,0,0,1,1735.94,266.31Zm-5.18-.44h0l-1.55-.11a.26.26,0,0,1,0-.52l1.56.11a.27.27,0,0,1,.24.28A.25.25,0,0,1,1730.76,265.87Zm-5.19-.36h0l-1.56-.1a.27.27,0,0,1-.24-.28.25.25,0,0,1,.27-.24l1.56.1a.26.26,0,0,1,.24.27A.26.26,0,0,1,1725.57,265.51Zm-5.19-.32h0l-1.56-.09a.26.26,0,0,1,0-.51l1.56.08a.26.26,0,0,1,.24.28A.25.25,0,0,1,1720.38,265.19Zm-5.19-.27h0l-1.56-.08a.27.27,0,0,1-.25-.27.26.26,0,0,1,.28-.25l1.55.08a.25.25,0,0,1,.25.27A.26.26,0,0,1,1715.19,264.92Zm-5.19-.25h0l-1.56-.07a.25.25,0,0,1-.25-.27.27.27,0,0,1,.27-.25l1.56.07a.27.27,0,0,1,.25.27A.26.26,0,0,1,1710,264.67Zm-5.2-.22h0l-1.56-.06a.26.26,0,0,1-.25-.27.27.27,0,0,1,.27-.25l1.56.07a.24.24,0,0,1,.25.26A.25.25,0,0,1,1704.8,264.45Zm-214,0h0a.26.26,0,0,1-.21-.3l.08-.49a.91.91,0,0,1,.9-.77h.14a.24.24,0,0,1,.26.26.26.26,0,0,1-.25.26h-.14a.39.39,0,0,0-.39.34l-.09.49A.26.26,0,0,1,1490.75,264.45Zm208.86-.19h0l-1.56-.05a.26.26,0,0,1-.25-.27.25.25,0,0,1,.27-.25l1.56.05a.27.27,0,0,1,.25.27A.26.26,0,0,1,1699.61,264.26Zm-5.2-.17h0l-1.56,0a.27.27,0,0,1-.25-.27.27.27,0,0,1,.27-.25l1.56.05a.26.26,0,0,1,0,.52Zm-5.2-.16h0l-1.56-.05a.26.26,0,0,1-.26-.26.27.27,0,0,1,.27-.26l1.56.05a.25.25,0,0,1,.25.27A.26.26,0,0,1,1689.21,263.93Zm-5.19-.14h0l-1.56,0a.26.26,0,0,1-.25-.27.24.24,0,0,1,.26-.25l1.56,0a.26.26,0,0,1,.26.26A.27.27,0,0,1,1684,263.79Zm-5.2-.13h0l-1.56,0a.26.26,0,0,1-.25-.26.25.25,0,0,1,.26-.26l1.56,0a.26.26,0,0,1,.26.26A.26.26,0,0,1,1678.82,263.66Zm-5.2-.12h0l-1.56,0a.26.26,0,0,1-.25-.27.27.27,0,0,1,.27-.25l1.56,0a.27.27,0,0,1,.25.27A.26.26,0,0,1,1673.62,263.54Zm-5.2-.1h0l-1.56,0a.26.26,0,0,1-.26-.27.24.24,0,0,1,.27-.25l1.56,0a.26.26,0,0,1,.25.26A.26.26,0,0,1,1668.42,263.44Zm-173.16-.08a.27.27,0,0,1-.26-.26.26.26,0,0,1,.26-.26l1.56,0a.27.27,0,0,1,.26.26.25.25,0,0,1-.25.26l-1.56,0Zm168,0h0l-1.56,0a.27.27,0,0,1-.26-.27.26.26,0,0,1,.26-.25h0l1.56,0a.26.26,0,0,1,0,.52Zm-162.75,0a.26.26,0,0,1-.26-.26.25.25,0,0,1,.25-.26l1.56,0a.25.25,0,0,1,.27.26.26.26,0,0,1-.26.26l-1.56,0Zm157.55,0h0l-1.56,0a.26.26,0,1,1,0-.52l1.56,0a.25.25,0,0,1,.25.26A.26.26,0,0,1,1658,263.26Zm-152.35,0a.26.26,0,0,1,0-.52l1.56,0a.26.26,0,1,1,0,.52l-1.56,0Zm5.2-.05a.26.26,0,0,1-.26-.26.25.25,0,0,1,.26-.26l1.56,0a.25.25,0,0,1,.26.26.26.26,0,0,1-.26.26l-1.56,0Zm142,0h0l-1.56,0a.26.26,0,0,1,0-.52h0l1.56,0a.27.27,0,0,1,.26.27A.26.26,0,0,1,1652.83,263.18Zm-136.76-.05a.26.26,0,0,1-.26-.25.27.27,0,0,1,.26-.27h1.56a.25.25,0,0,1,.26.26.26.26,0,0,1-.26.26Zm131.56,0h0l-1.56,0a.26.26,0,0,1,0-.52l1.56,0a.27.27,0,0,1,.26.27A.26.26,0,0,1,1647.63,263.11Zm-126.36,0a.26.26,0,0,1,0-.52l1.56,0h0a.26.26,0,0,1,.26.26.25.25,0,0,1-.26.26l-1.56,0Zm121.16,0h-1.57a.27.27,0,0,1-.25-.27.25.25,0,0,1,.26-.25h1.56a.27.27,0,0,1,.26.27A.26.26,0,0,1,1642.43,263.05Zm-116,0a.26.26,0,0,1-.26-.25.27.27,0,0,1,.26-.27H1528a.26.26,0,0,1,0,.52h-1.56Zm5.2,0a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,0,.52h-1.57Zm105.56,0h0l-1.56,0a.25.25,0,0,1-.26-.26.26.26,0,0,1,.26-.26h0l1.56,0a.26.26,0,1,1,0,.52Zm-100.36,0a.27.27,0,0,1-.26-.26.26.26,0,0,1,.26-.26l1.56,0a.26.26,0,0,1,.26.26.24.24,0,0,1-.25.26l-1.56,0Zm95.16,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26H1632a.27.27,0,0,1,.26.27A.26.26,0,0,1,1632,263Zm-90,0a.26.26,0,0,1,0-.52h1.57a.27.27,0,0,1,.26.26.26.26,0,0,1-.26.26Zm84.75,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,1,1,0,.52Zm-79.55,0a.26.26,0,0,1,0-.52h1.57a.26.26,0,0,1,0,.52Zm74.35,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1621.63,262.88Zm-69.15,0a.25.25,0,0,1-.26-.26.26.26,0,0,1,.26-.26H1554a.26.26,0,0,1,.26.26.26.26,0,0,1-.26.26Zm64,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.26.26,0,0,1,1616.43,262.85Zm-58.75,0a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,0,.52Zm5.2,0a.26.26,0,0,1-.26-.26.25.25,0,0,1,.26-.26h1.56a.26.26,0,0,1,0,.52Zm48.35,0h-1.56a.26.26,0,0,1,0-.52h1.56a.25.25,0,0,1,.26.26A.26.26,0,0,1,1611.23,262.83Zm-43.15,0a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26.26.26,0,0,1-.26.26Zm38,0h-1.56a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26H1606a.25.25,0,0,1,.26.26A.26.26,0,0,1,1606,262.81Zm-32.75,0a.26.26,0,0,1-.26-.26.25.25,0,0,1,.26-.26h1.56a.26.26,0,0,1,.26.26.26.26,0,0,1-.26.26Zm27.55,0h-1.56a.26.26,0,0,1,0-.52h1.56a.26.26,0,0,1,.26.26A.25.25,0,0,1,1600.83,262.79Zm-22.35,0a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26H1580a.26.26,0,0,1,.26.26.26.26,0,0,1-.26.26Zm17.15,0h-1.56a.24.24,0,0,1-.25-.26.26.26,0,0,1,.26-.26h1.56a.24.24,0,0,1,.25.26A.26.26,0,0,1,1595.63,262.79Zm-12,0a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h1.56a.26.26,0,0,1,0,.52Zm6.76,0h-1.56a.26.26,0,1,1,0-.52h1.56a.26.26,0,0,1,0,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1638.77,382.15h-34.08a8.8,8.8,0,0,1-8.76-7.74L1592,341.62a8.79,8.79,0,0,1,8.76-9.82h40.94a8.8,8.8,0,0,1,8.79,9.55l-2.92,32.8A8.81,8.81,0,0,1,1638.77,382.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1634.58,367.15h-25.94c-3.4,0-6.26-1.93-6.67-4.51l-3-19.12c-.48-3,2.64-5.73,6.66-5.73h31.16c4,0,7,2.58,6.69,5.57l-2.23,19.13C1641,365.13,1638.06,367.15,1634.58,367.15Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 1382.21,
    cy: 286.01,
    r: 27.72,
    transform: "translate(589.02 1453.55) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 1382.21,
    cy: 286.01,
    r: 26.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1360.11,275.92a1.12,1.12,0,0,1-.47-.11,1,1,0,0,1-.46-1.4,25.8,25.8,0,0,1,27.67-13.76,1,1,0,0,1-.37,2.05A23.69,23.69,0,0,0,1361,275.35,1,1,0,0,1,1360.11,275.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1382.79,
    cy: 286.59,
    r: 22.68,
    transform: "translate(-28.05 225.2) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1380.56,303.45V301a20.08,20.08,0,0,1-6.92-1.51,1.43,1.43,0,0,1-.79-1.68l.63-2.3a1.43,1.43,0,0,1,2-.94,16.74,16.74,0,0,0,6.39,1.34c2.48,0,4.33-.84,4.33-2.56,0-1.55-1.43-2.47-4.87-3.4-4.92-1.34-8.44-3.48-8.44-7.81,0-3.9,2.85-6.89,7.81-7.68V272a1.43,1.43,0,0,1,1.44-1.44h1.45A1.43,1.43,0,0,1,1385,272v2.21a18.57,18.57,0,0,1,5.49,1,1.43,1.43,0,0,1,.89,1.73l-.57,2.12a1.43,1.43,0,0,1-1.89,1,15,15,0,0,0-5.39-1c-2.94,0-3.78,1.22-3.78,2.31,0,1.35,1.77,2.27,5.59,3.45,5.46,1.63,7.73,3.9,7.73,8,0,3.74-2.78,7.1-8.15,7.94v2.76a1.43,1.43,0,0,1-1.44,1.44H1382A1.44,1.44,0,0,1,1380.56,303.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 1461.1,
    cy: 253.14,
    r: 48.25,
    transform: "translate(-21.68 237.31) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1461.1,
    cy: 253.14,
    r: 46.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1422.64,234.8a1,1,0,0,1-.47-.11,1,1,0,0,1-.46-1.4A43.91,43.91,0,0,1,1461.1,209a45,45,0,0,1,8,.71,1,1,0,1,1-.37,2.05,42.76,42.76,0,0,0-7.59-.68,41.83,41.83,0,0,0-37.53,23.11A1,1,0,0,1,1422.64,234.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1462.12,
    cy: 254.15,
    r: 39.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1458.25,283.51v-4.3a35.27,35.27,0,0,1-12.06-2.61,2.49,2.49,0,0,1-1.37-2.94l1.09-4a2.5,2.5,0,0,1,3.4-1.64,29,29,0,0,0,11.13,2.35c4.31,0,7.53-1.47,7.53-4.46,0-2.71-2.49-4.32-8.48-5.92-8.55-2.34-14.69-6.07-14.69-13.6,0-6.8,5-12,13.59-13.38v-4.29a2.51,2.51,0,0,1,2.51-2.51h2.52a2.5,2.5,0,0,1,2.5,2.51v3.85a32.14,32.14,0,0,1,9.56,1.72,2.49,2.49,0,0,1,1.55,3l-1,3.7a2.5,2.5,0,0,1-3.3,1.69,26.12,26.12,0,0,0-9.37-1.7c-5.11,0-6.58,2.12-6.58,4,0,2.34,3.07,3.95,9.73,6,9.5,2.85,13.45,6.8,13.45,13.89,0,6.51-4.83,12.36-14.18,13.82v4.81a2.5,2.5,0,0,1-2.51,2.5h-2.52A2.5,2.5,0,0,1,1458.25,283.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 1494.38,
    cy: 360.91,
    r: 49.65,
    transform: "translate(799.79 1732.4) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 1494.38,
    cy: 360.91,
    r: 48,
    transform: "translate(589.07 1603.42) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1454.8,342a1,1,0,0,1-.47-.11,1,1,0,0,1-.46-1.4,45.4,45.4,0,0,1,48.69-24.2,1,1,0,1,1-.37,2.05,43.29,43.29,0,0,0-46.46,23.09A1,1,0,0,1,1454.8,342Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1495.43,
    cy: 361.96,
    r: 40.63,
    transform: "translate(799.57 1734.22) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1491.44,392.16v-4.42a36.09,36.09,0,0,1-12.4-2.69,2.54,2.54,0,0,1-1.41-3l1.12-4.12a2.57,2.57,0,0,1,3.5-1.68,30,30,0,0,0,11.45,2.41c4.44,0,7.75-1.51,7.75-4.59,0-2.78-2.56-4.44-8.73-6.09-8.8-2.41-15.12-6.25-15.12-14,0-7,5.12-12.34,14-13.77v-4.42a2.57,2.57,0,0,1,2.58-2.57h2.59a2.57,2.57,0,0,1,2.58,2.57v4a33,33,0,0,1,9.83,1.76,2.57,2.57,0,0,1,1.6,3.1l-1,3.81a2.57,2.57,0,0,1-3.39,1.73,26.8,26.8,0,0,0-9.64-1.75c-5.27,0-6.77,2.18-6.77,4.14,0,2.4,3.16,4.06,10,6.16,9.78,2.94,13.84,7,13.84,14.3,0,6.69-5,12.71-14.59,14.21v5a2.57,2.57,0,0,1-2.58,2.57H1494A2.57,2.57,0,0,1,1491.44,392.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 1558.08,
    cy: 293.28,
    r: 36.38,
    transform: "translate(-20.47 440.9) rotate(-16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 1558.08,
    cy: 293.28,
    r: 35.17,
    transform: "translate(103.46 923.93) rotate(-34.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1529.08,279.71a1.12,1.12,0,0,1-.47-.11,1,1,0,0,1-.46-1.4,33.36,33.36,0,0,1,29.93-18.43,33.84,33.84,0,0,1,6,.55,1,1,0,1,1-.37,2,32.58,32.58,0,0,0-5.67-.51A31.29,31.29,0,0,0,1530,279.14,1.05,1.05,0,0,1,1529.08,279.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1558.84,
    cy: 294.04,
    r: 29.77,
    transform: "translate(-25.86 366.02) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1555.92,316.17v-3.24a26.23,26.23,0,0,1-9.08-2,1.87,1.87,0,0,1-1-2.21l.82-3a1.9,1.9,0,0,1,2.57-1.23,21.81,21.81,0,0,0,8.39,1.77c3.25,0,5.67-1.11,5.67-3.37,0-2-1.87-3.25-6.39-4.46-6.45-1.76-11.08-4.57-11.08-10.25,0-5.13,3.75-9,10.25-10.09v-3.24a1.89,1.89,0,0,1,1.89-1.88h1.9a1.89,1.89,0,0,1,1.89,1.88v2.91a24,24,0,0,1,7.2,1.3,1.86,1.86,0,0,1,1.17,2.26l-.75,2.79a1.88,1.88,0,0,1-2.49,1.27,19.6,19.6,0,0,0-7.06-1.28c-3.86,0-5,1.6-5,3,0,1.76,2.31,3,7.33,4.52,7.16,2.15,10.14,5.13,10.14,10.47,0,4.91-3.64,9.32-10.69,10.42v3.62a1.89,1.89,0,0,1-1.89,1.89h-1.9A1.89,1.89,0,0,1,1555.92,316.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 537.17,
    y: 1266.03,
    width: 1137.86,
    height: 131.89,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 447.78,
    y: 1360.58,
    width: 1282.23,
    height: 57.06,
    rx: 7.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1642,762.89H564c-16.2,0-20.45-22.4-5.38-28.33l539-212.22a14.7,14.7,0,0,1,10.76,0l539,212.22C1662.43,740.49,1658.18,762.89,1642,762.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 599.65,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 634.32,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 668.99,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "717.54 771.16 574.22 771.16 574.22 777.38 595.02 787.34 696.73 787.34 717.54 777.38 717.54 771.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "718.69 1256.59 575.38 1256.59 575.38 1234.18 596.18 1224.23 697.89 1224.23 718.69 1234.18 718.69 1256.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 782.26,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 816.93,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 851.61,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "900.15 771.16 756.83 771.16 756.83 777.38 777.64 787.34 879.35 787.34 900.15 777.38 900.15 771.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "901.3 1256.59 757.99 1256.59 757.99 1234.18 778.79 1224.23 880.5 1224.23 901.3 1234.18 901.3 1256.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 964.87,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 999.55,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1034.22,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1082.76 771.16 939.45 771.16 939.45 777.38 960.25 787.34 1061.96 787.34 1082.76 777.38 1082.76 771.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1083.92 1256.59 940.6 1256.59 940.6 1234.18 961.41 1224.23 1063.11 1224.23 1083.92 1234.18 1083.92 1256.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1157.49,
    y: 800.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1192.16,
    y: 800.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1226.83,
    y: 800.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1275.38 777.16 1132.06 777.16 1132.06 783.38 1152.86 793.34 1254.57 793.34 1275.38 783.38 1275.38 777.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1276.53 1262.59 1133.21 1262.59 1133.21 1240.18 1154.02 1230.23 1255.73 1230.23 1276.53 1240.18 1276.53 1262.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1330.1,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1364.77,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1399.45,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1447.99 771.16 1304.67 771.16 1304.67 777.38 1325.48 787.34 1427.18 787.34 1447.99 777.38 1447.99 771.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1449.14 1256.59 1305.83 1256.59 1305.83 1234.18 1326.63 1224.23 1428.34 1224.23 1449.14 1234.18 1449.14 1256.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1512.71,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1547.38,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1582.06,
    y: 794.28,
    width: 23.12,
    height: 425.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1630.6 771.16 1487.29 771.16 1487.29 777.38 1508.09 787.34 1609.8 787.34 1630.6 777.38 1630.6 771.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1631.76 1256.59 1488.44 1256.59 1488.44 1234.18 1509.24 1224.23 1610.95 1224.23 1631.76 1234.18 1631.76 1256.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 537.17,
    y: 1266.15,
    width: 1138.89,
    height: 24.82,
    rx: 3.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1080.18,
    cy: 258.81,
    r: 197.85,
    transform: "translate(133.37 839.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1080.57,
    cy: 260.96,
    r: 179.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1154.71,258.28c-14.84-17.22-11.08-28.54-4.07-38.85l6.83,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1154.71,258.28q-10-19.42-4.07-38.85c-14.65,5-23.85,13.7-24.71,28.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1133.79,
    y: 375.16,
    width: 21.99,
    height: 35.43,
    rx: 10.74,
    transform: "translate(2289.57 785.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1036.32,
    y: 378.26,
    width: 21.99,
    height: 35.43,
    rx: 10.74,
    transform: "translate(2094.63 791.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1090.89,236.71c54.32,0,99.35,30,107.48,69.28h7.9a9.85,9.85,0,0,1,9.85,9.86v21.32a9.86,9.86,0,0,1-9.85,9.86h-13.22c-15.27,31.38-55.25,53.77-102.16,53.77-60.09,0-108.8-36.73-108.8-82S1030.8,236.71,1090.89,236.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 1154.71,
    cy: 297.05,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1041.21,251.33c20.22-6.56,31.77-8.47,50-8.28a1.09,1.09,0,0,0,1.1-1.05h0a1.08,1.08,0,0,0-1.08-1.13c-18.52-.2-30.27,1.74-50.72,8.36a1.1,1.1,0,0,0-.67,1.47v0A1.11,1.11,0,0,0,1041.21,251.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1136.1,254.65c-20-23.24-14.95-38.54-5.49-52.45l9.22,47.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1136.1,254.65q-13.49-26.22-5.49-52.45c-19.79,6.72-32.2,18.49-33.37,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M994.08,306.34s0-.35-.12-1q0-.24-.06-.54c-.06-.29-.12-.61-.18-.95l-.23-1.1c-.09-.39-.21-.72-.33-1.11a19.19,19.19,0,0,0-2.51-5.15,19.6,19.6,0,0,0-13.12-8.33c-.75-.1-1.52-.17-2.29-.21h-2.19l-.23,0-.47.06a5.49,5.49,0,0,0-.55.07l-1.39.28a16.47,16.47,0,0,0-2.42.84,15.68,15.68,0,0,0-4.33,2.8,15.92,15.92,0,0,0-3.22,4.11,15.11,15.11,0,0,0-1.7,5,15.44,15.44,0,0,0-.18,2.63v.95l0,.12,0,.26.06.54.15.76a7.13,7.13,0,0,0,.17.73l.2.66a11.6,11.6,0,0,0,.51,1.27,10.67,10.67,0,0,0,.63,1.21c.22.39.5.75.75,1.12a12.56,12.56,0,0,0,4,3.47,12.38,12.38,0,0,0,4.94,1.47,9,9,0,0,0,1.27,0H972l.5-.06a6.28,6.28,0,0,0,.65-.11c.23-.05.49-.09.7-.15a10.38,10.38,0,0,0,1.22-.43,10,10,0,0,0,6-7.16,7,7,0,0,0,.17-1.12c0-.18,0-.37.05-.55v-1.17l0-.43A8.76,8.76,0,0,0,981,304a8,8,0,0,0-.87-2,7.64,7.64,0,0,0-1.3-1.61,7.9,7.9,0,0,0-6.63-2.15,6.45,6.45,0,0,0-4.61,3.18,6.19,6.19,0,0,0-.72,1.94,6.55,6.55,0,0,0-.11,1.51,5.11,5.11,0,0,0,.14,1c.05.22.08.33.08.33a1.26,1.26,0,0,0,2.43-.61v0l0-.17a2.34,2.34,0,0,1,0-.51,3.71,3.71,0,0,1,.65-1.94,3.62,3.62,0,0,1,1-1,4,4,0,0,1,.72-.33,3,3,0,0,1,.75-.17H973a4.07,4.07,0,0,1,.49.05,4.49,4.49,0,0,1,2.73,1.49,5.06,5.06,0,0,1,.63.93,5,5,0,0,1,.36,1.09,1.12,1.12,0,0,1,0,.24l0,.11v.15l0,.44v.1c0-.19,0,0,0-.08v.23l0,.32c0,.11,0,.21-.06.32a3.5,3.5,0,0,1-.15.64,5.54,5.54,0,0,1-3.62,3.66,4.91,4.91,0,0,1-.66.17l-.26,0a1.83,1.83,0,0,1-.33,0l-.5,0h-.13c-.12,0,.14,0,.1,0h-.25a6,6,0,0,1-.74-.09,7,7,0,0,1-2.74-1.09,6.78,6.78,0,0,1-2-2.09c-.11-.22-.25-.42-.35-.65a6.72,6.72,0,0,1-.28-.67c-.06-.23-.16-.45-.2-.69l-.08-.35c0-.11,0-.19,0-.28a1.93,1.93,0,0,0,0-.27l0-.51v-.49c0-.05,0,.28,0,.13l0-.39a8.6,8.6,0,0,1,.24-1.52,8.5,8.5,0,0,1,1.21-2.73,8.91,8.91,0,0,1,2-2.12,8.3,8.3,0,0,1,2.46-1.29,9.08,9.08,0,0,1,1.27-.32,4,4,0,0,0,.5-.06,3,3,0,0,1,.4,0h.74l.35,0,.69.05q.67.11,1.32.24a11.33,11.33,0,0,1,4.33,2.18A10.64,10.64,0,0,1,983,301.4a9.4,9.4,0,0,1,1.08,2.84,5.2,5.2,0,0,1,.12.56c0,.14,0,.27,0,.4l.06.34,0,.55,0,1a4.91,4.91,0,0,0,9.81-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1013.26,364.33a1,1,0,0,1-.59-.21A80.56,80.56,0,0,1,990.92,338a.94.94,0,1,1,1.67-.85,78.75,78.75,0,0,0,21.25,25.55A.93.93,0,0,1,1014,364,1,1,0,0,1,1013.26,364.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1097.43,391.65c-23.64,0-48.16-5.92-67.84-16.43a.94.94,0,1,1,.88-1.65c20.46,10.93,46.25,16.82,70.74,16.15,25.49-.69,47.26-8.22,61.28-21.18a.93.93,0,1,1,1.26,1.37c-14.35,13.27-36.54,21-62.49,21.68C1100,391.63,1098.71,391.65,1097.43,391.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 936.46,
    cy: 103.79,
    r: 28.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 936.46,
    cy: 103.79,
    r: 27.17,
    transform: "translate(620.29 991.35) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M914.05,93.64a1.16,1.16,0,0,1-.51-.12A1.14,1.14,0,0,1,913,92a26.12,26.12,0,0,1,23.43-14.43,26.67,26.67,0,0,1,4.73.43,1.14,1.14,0,1,1-.41,2.24,25,25,0,0,0-4.32-.38A23.84,23.84,0,0,0,915.07,93,1.15,1.15,0,0,1,914.05,93.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 937.05,
    cy: 104.38,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M934.79,121.48V119a20.56,20.56,0,0,1-7-1.52,1.46,1.46,0,0,1-.8-1.71l.64-2.34a1.46,1.46,0,0,1,2-1,17,17,0,0,0,6.48,1.36c2.51,0,4.39-.85,4.39-2.59,0-1.58-1.45-2.52-4.94-3.45-5-1.36-8.56-3.54-8.56-7.92,0-4,2.89-7,7.92-7.8v-2.5a1.46,1.46,0,0,1,1.46-1.46h1.47a1.46,1.46,0,0,1,1.45,1.46v2.25a18.74,18.74,0,0,1,5.57,1,1.46,1.46,0,0,1,.91,1.75l-.59,2.16a1.45,1.45,0,0,1-1.92,1,15.08,15.08,0,0,0-5.46-1c-3,0-3.83,1.23-3.83,2.34,0,1.36,1.79,2.3,5.66,3.49,5.54,1.66,7.84,4,7.84,8.09,0,3.79-2.81,7.2-8.26,8.05v2.8a1.46,1.46,0,0,1-1.46,1.46h-1.47A1.46,1.46,0,0,1,934.79,121.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 1016.47,
    cy: 70.46,
    r: 48.93,
    transform: "translate(784.1 1062.51) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 1016.47,
    cy: 70.46,
    r: 47.31,
    transform: "translate(422.15 898.08) rotate(-58.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M977.46,52a1,1,0,0,1-.51-.13,1.15,1.15,0,0,1-.51-1.53,44.63,44.63,0,0,1,40-24.64,45.38,45.38,0,0,1,8.08.72,1.15,1.15,0,0,1,.92,1.33,1.13,1.13,0,0,1-1.33.92,42.6,42.6,0,0,0-45.66,22.7A1.14,1.14,0,0,1,977.46,52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 1017.5,
    cy: 71.49,
    r: 40.04,
    transform: "translate(714.15 1045.34) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1013.57,101.25V96.9a35.85,35.85,0,0,1-12.22-2.65,2.52,2.52,0,0,1-1.39-3l1.1-4.06a2.54,2.54,0,0,1,3.45-1.66,29.45,29.45,0,0,0,11.29,2.38c4.37,0,7.63-1.49,7.63-4.53,0-2.74-2.52-4.37-8.6-6-8.67-2.37-14.9-6.15-14.9-13.79,0-6.89,5-12.16,13.79-13.57V45.69a2.54,2.54,0,0,1,2.54-2.54h2.56a2.54,2.54,0,0,1,2.54,2.54V49.6a32.44,32.44,0,0,1,9.68,1.74,2.52,2.52,0,0,1,1.58,3l-1,3.75a2.52,2.52,0,0,1-3.34,1.71,26.26,26.26,0,0,0-9.5-1.73c-5.19,0-6.67,2.15-6.67,4.08,0,2.37,3.11,4,9.86,6.08,9.64,2.89,13.64,6.89,13.64,14.09,0,6.59-4.89,12.52-14.38,14v4.87a2.54,2.54,0,0,1-2.54,2.54h-2.56A2.54,2.54,0,0,1,1013.57,101.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 1050.22,
    cy: 179.75,
    r: 50.35,
    transform: "translate(11.16 415.58) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 1050.22,
    cy: 179.75,
    r: 48.68,
    transform: "translate(482.25 1081.24) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1010.08,160.67a1.2,1.2,0,0,1-.52-.12,1.15,1.15,0,0,1-.5-1.54,45.88,45.88,0,0,1,41.16-25.34,47.21,47.21,0,0,1,8.31.75,1.14,1.14,0,0,1-.41,2.25,43.88,43.88,0,0,0-47,23.37A1.15,1.15,0,0,1,1010.08,160.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 1051.28,
    cy: 180.81,
    r: 41.2,
    transform: "translate(633.77 1162.42) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1047.23,211.44V207a36.51,36.51,0,0,1-12.57-2.73,2.6,2.6,0,0,1-1.44-3.06l1.14-4.18a2.62,2.62,0,0,1,3.55-1.71,30.28,30.28,0,0,0,11.61,2.45c4.5,0,7.86-1.53,7.86-4.66,0-2.82-2.59-4.5-8.85-6.18-8.92-2.44-15.33-6.33-15.33-14.18,0-7.1,5.19-12.51,14.19-14v-4.49a2.61,2.61,0,0,1,2.61-2.61h2.63a2.61,2.61,0,0,1,2.61,2.61v4a33.08,33.08,0,0,1,10,1.79,2.61,2.61,0,0,1,1.63,3.14l-1,3.86a2.61,2.61,0,0,1-3.44,1.76,27.17,27.17,0,0,0-9.78-1.78c-5.34,0-6.86,2.21-6.86,4.2,0,2.44,3.2,4.12,10.14,6.25,9.92,3,14,7.1,14,14.49,0,6.79-5,12.9-14.8,14.42v5a2.61,2.61,0,0,1-2.61,2.61h-2.63A2.61,2.61,0,0,1,1047.23,211.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 1114.81,
    cy: 111.16,
    r: 36.89,
    transform: "translate(826.51 1193.77) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 1114.81,
    cy: 111.16,
    r: 35.67,
    transform: "translate(585.49 1098.57) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1085.4,97.49a1,1,0,0,1-.51-.13,1.14,1.14,0,0,1-.51-1.53A34.14,34.14,0,0,1,1121,77.65a1.14,1.14,0,0,1-.4,2.25,31.81,31.81,0,0,0-34.13,17A1.14,1.14,0,0,1,1085.4,97.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 1115.59,
    cy: 111.94,
    r: 30.19,
    transform: "translate(-5.32 137.14) rotate(-7.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1112.63,134.38V131.1a26.94,26.94,0,0,1-9.22-2,1.9,1.9,0,0,1-1.05-2.25l.84-3.06a1.9,1.9,0,0,1,2.59-1.25,22.29,22.29,0,0,0,8.51,1.79c3.3,0,5.76-1.12,5.76-3.41,0-2.06-1.9-3.29-6.48-4.52-6.54-1.79-11.24-4.64-11.24-10.4,0-5.2,3.8-9.17,10.4-10.23V92.49a1.91,1.91,0,0,1,1.91-1.92h1.93a1.91,1.91,0,0,1,1.91,1.92v3a24.34,24.34,0,0,1,7.31,1.31,1.9,1.9,0,0,1,1.19,2.3l-.77,2.83a1.91,1.91,0,0,1-2.52,1.29,19.82,19.82,0,0,0-7.16-1.31c-3.91,0-5,1.63-5,3.08,0,1.79,2.35,3,7.43,4.58,7.27,2.18,10.29,5.2,10.29,10.62,0,5-3.69,9.45-10.85,10.56v3.68a1.9,1.9,0,0,1-1.91,1.91h-1.93A1.9,1.9,0,0,1,1112.63,134.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1744.31,1348.28a4.17,4.17,0,0,1,.18-1.41,3.73,3.73,0,0,1,.28-.68,2.45,2.45,0,0,1,.26-.44l.32-.45.62-.85,1.2-1.56,2.39-3,4.81-6,9.68-11.79,19.47-23.46,39.13-46.75a5.22,5.22,0,0,1,8,6.7.69.69,0,0,1-.11.13l0,0-40.79,45.25-20.3,22.7-10.08,11.39-5,5.72-2.45,2.87-1.18,1.42-.52.66-.25.32c-.07.09.08-.11.14-.24a2.16,2.16,0,0,0,.16-.47,2,2,0,0,0,0-1,3,3,0,1,1-5.89.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2002.39,1411c12.44,4.5,24.77,7.93,33,10-5.78-7.6-19.32-24.41-32.21-33.44l-9.64-3.64s-4.9,4-9.69,15.25C1984.89,1401.75,1988.77,1406.06,2002.39,1411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2035.52,1421.14l-.08-.1c-8.28-2.12-20.61-5.55-33-10-13.62-4.93-17.5-9.24-18.49-11.78-.22.52-.44,1-.66,1.58a4.81,4.81,0,0,0,2.68,6.28c10.09,4,35.17,13.72,47.72,16.92A1.81,1.81,0,0,0,2035.52,1421.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1995.75,1370.19c1.38.38-2.73,6.87-2.83,14.48a3.75,3.75,0,0,0,2.4,3.85c1.06.34,2.32.71,3.63,1a4.14,4.14,0,0,0,4.75-2.44l7.3-17.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1859.86,1484c13.21.68,26,.36,34.55,0-7.75-5.58-25.6-17.71-40.56-22.58l-7.12-.47a4.73,4.73,0,0,0-4.69,2.91,54,54,0,0,0-3.3,14.3C1840.43,1480.31,1845.4,1483.3,1859.86,1484Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1894.51,1484.09l-.1-.08c-8.54.39-21.34.71-34.55,0-14.46-.74-19.43-3.73-21.12-5.87-.06.56-.12,1.11-.17,1.7a4.82,4.82,0,0,0,4.4,5.23c10.81.87,37.64,2.87,50.58,2.26A1.8,1.8,0,0,0,1894.51,1484.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1847.75,1447.07c1.43,0-2.43,8.55-2.47,16.08,0,1.71,1.7,2.94,3.42,3,1.11,0,2.43,0,3.77-.09a4.13,4.13,0,0,0,3.83-3.71l7.14-17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1844.37,1452.44c5.41-22.16,43.41-175.39,69.21-209.14l35.4,5.19,4.22-5.19s86.57,25.35,96.46,34.86c8.12,7.8-38.43,102.37-38.43,102.37a19.48,19.48,0,0,1-18.76-4.15l14.7-66a5,5,0,0,0-3.83-6l-65.69-14a5.6,5.6,0,0,0-6.26,3.1c-13.89,29.54-61.63,132.11-69.9,163.79a2,2,0,0,1-2,1.47,48.21,48.21,0,0,1-13-2.3A3.38,3.38,0,0,1,1844.37,1452.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1935.19,1288.06a.86.86,0,0,1-.59-.24.84.84,0,0,1,0-1.19l8.57-8.76a.85.85,0,0,1,1.19,0,.84.84,0,0,1,0,1.19l-8.57,8.77A.82.82,0,0,1,1935.19,1288.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1858.15,1193.65c-11.29,16.94-21.57,34.43-29,51l10.56,4.5s14.8-19.14,34.54-41.24A36.91,36.91,0,0,0,1858.15,1193.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1939.47,1148.28l6.3-53s-53.23,46.67-87.62,98.32a36.91,36.91,0,0,1,16.13,14.25C1894.36,1185.4,1919.56,1159.85,1939.47,1148.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1832.71,1244.64s-17.18-.36-19.38,4.5,4.4,15,6.6,15.88,12.34-1.76,12.78-6.61,5.24-2.24,7-9.27S1832.71,1244.64,1832.71,1244.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2011.69,1058.66s-34.21,22.49-47.32,34.58l28.92,14.42s14.41-18.3,28.59-26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1902,1259.36c10,15.36,37,2.73,71.81-9,.69-.24,1-8.37,1.12-9.09,1.66-8.83,13.59-59.16,23.1-80.88a2,2,0,0,1,3-.85c8.67,6.06,45.66,28.81,97.71,17.17a2,2,0,0,0,1.59-1.81l.45-5a2,2,0,0,0-1.77-2.21c-9.88-1.3-54.94-8.43-77.72-33.35-25.68-28.09-8.84-36.64-23.31-44.65-7.94-4.39-13.11-7.6-16.15-9.61-.83-.54-3.45-.49-7.37.21-17.86,3.21-32.55,17.2-32.55,17.2C1904.65,1133,1899.08,1254.92,1902,1259.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2094.51,1167l6.28.83,18.44-6.94a9.79,9.79,0,0,1,7.53-.33l20.18,7.38-50.56,9.21C2095.52,1175.67,2096.35,1168.89,2094.51,1167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2045.32,1041.78c.13.67-6.92,45.72-6.92,45.72l-25.63-4.57.33-43.68S2043.14,1030.44,2045.32,1041.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2018.26,1048.69l-2,23a3.18,3.18,0,0,0,0,.87c.34,1.78,2,7.81,8,5.78,5.51-1.83,10.57-3.43,14.15-2.51a3.22,3.22,0,0,1,2.39,3.61,139.37,139.37,0,0,1-4.88,21.07,3.22,3.22,0,0,1-3.81,2.08c-4.88-1.19-15.09-4-22.79-8.12a3.23,3.23,0,0,1-1.7-2.82c0-5.78-.16-23.34-1-28.23-.75-4.59-6.54-7.09-9-8a3.14,3.14,0,0,1-1.84-1.68c-1.27-2.8-3.15-9.33,5-12.43a3.22,3.22,0,0,0,1.84-4.26c-1.39-3.37-2.15-8.58,4.16-11.77s11.45,0,14.22,2.74a3.24,3.24,0,0,0,4.13.3,2.56,2.56,0,0,1,2.9,0,3.17,3.17,0,0,0,4.43-1.57c1.42-3.29,4.45-6.88,10.91-6.08,11.46,1.42,13.33,14,10.67,21.48s-15,5.27-21.29,1.84c-4.79-2.62-10.69.63-13.24,2.33A3.18,3.18,0,0,0,2018.26,1048.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M2008.34,1071.23s2.85-12.75-2.1-15.73-12-1-10,8.42C1998.75,1075.62,2008.34,1071.23,2008.34,1071.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 1569.55,
    cy: 1450.66,
    r: 44.96,
    transform: "translate(-202.91 2644.93) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1569.55,
    cy: 1452.98,
    r: 32.65,
    transform: "translate(-373.47 2347.02) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1580,1450.66a10.43,10.43,0,1,1-10.43-10.43A10.43,10.43,0,0,1,1580,1450.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1688.88,
    cy: 1450.66,
    rx: 45.12,
    ry: 44.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1684.05,
    cy: 1448.16,
    rx: 27.95,
    ry: 27.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1699.34,1450.66a10.47,10.47,0,1,1-10.46-10.43A10.44,10.44,0,0,1,1699.34,1450.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1491.69,1368.89l9.22,28.92c1.65,5.18,7.09,8.75,13.26,8.7l228.35-2.9c6,0,11.24-3.49,13-8.49l10.8-31.57c2.64-7.69-4.07-15.4-13.29-15.26l-248.38,5.56C1495.68,1354,1489.3,1361.41,1491.69,1368.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1508.1,1380.55,1749.72,1369a3.43,3.43,0,0,1,3.3,4.68l-1.92,4.9a3.43,3.43,0,0,1-3.13,2.19l-239.7,6.69a3.44,3.44,0,0,1-3.37-2.5h0A3.44,3.44,0,0,1,1508.1,1380.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-75",
    cx: 1626.31,
    cy: 1053.67,
    r: 89.34,
    transform: "translate(-268.72 1458.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-76",
    cx: 1626.31,
    cy: 1053.67,
    r: 86.37,
    transform: "translate(325.74 2490.2) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1555.09,1019.78a1.89,1.89,0,0,1-.89-.22,2,2,0,0,1-.88-2.67,81.37,81.37,0,0,1,73-44.94,82.46,82.46,0,0,1,14.74,1.33,2,2,0,0,1-.71,3.91,77.8,77.8,0,0,0-83.47,41.5A2,2,0,0,1,1555.09,1019.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 1628.19,
    cy: 1055.55,
    r: 73.1,
    transform: "translate(249.25 2420.73) rotate(-77.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1621,1109.9v-8a65.1,65.1,0,0,1-22.32-4.83,4.61,4.61,0,0,1-2.54-5.44l2-7.41a4.64,4.64,0,0,1,6.3-3,53.84,53.84,0,0,0,20.6,4.34c8,0,13.94-2.71,13.94-8.26,0-5-4.6-8-15.7-11-15.83-4.34-27.2-11.24-27.2-25.18,0-12.59,9.2-22.2,25.17-24.77v-7.95a4.64,4.64,0,0,1,4.64-4.64h4.67a4.63,4.63,0,0,1,4.63,4.64v7.14a59.5,59.5,0,0,1,17.69,3.17,4.62,4.62,0,0,1,2.88,5.57l-1.86,6.85a4.61,4.61,0,0,1-6.1,3.12,48.3,48.3,0,0,0-17.34-3.15c-9.48,0-12.19,3.93-12.19,7.45,0,4.33,5.69,7.31,18,11.1,17.59,5.28,24.9,12.58,24.9,25.71,0,12-8.93,22.88-26.26,25.59v8.9a4.63,4.63,0,0,1-4.63,4.63h-4.68A4.63,4.63,0,0,1,1621,1109.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 1535.41,
    y: 1155.24,
    width: 181.81,
    height: 31.25,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1542.61,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1556.24,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1569.87,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1583.51,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1597.14,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1610.78,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1624.41,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1638.04,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1651.68,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1665.31,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1678.95,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1692.58,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1706.21,
    y: 1160.85,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1535.41,
    y: 1189.95,
    width: 181.81,
    height: 31.25,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1542.61,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1556.24,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1569.87,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1583.51,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 1597.14,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1610.78,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1624.41,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1638.04,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1651.68,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1665.31,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1678.95,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1692.58,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1706.21,
    y: 1195.55,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1535.41,
    y: 1224.65,
    width: 181.81,
    height: 31.25,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1542.61,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1556.24,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1569.87,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1583.51,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1597.14,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1610.78,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1624.41,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1638.04,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 1651.68,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 1665.31,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 1678.95,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1692.58,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 1706.21,
    y: 1230.26,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1535.41,
    y: 1259.36,
    width: 181.81,
    height: 31.25,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1542.61,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 1556.24,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 1569.87,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 1583.51,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 1597.14,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1610.78,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 1624.41,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 1638.04,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 1651.68,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1665.31,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1678.95,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 1692.58,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1706.21,
    y: 1264.97,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1535.41,
    y: 1294.07,
    width: 181.81,
    height: 31.25,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1542.61,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1556.24,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 1569.87,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1583.51,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 1597.14,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 1610.78,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 1624.41,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 1638.04,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 1651.68,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 1665.31,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 1678.95,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 1692.58,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 1706.21,
    y: 1299.68,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 1535.41,
    y: 1328.78,
    width: 181.81,
    height: 31.25,
    rx: 4.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1542.61,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 1556.24,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1569.87,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 1583.51,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1597.14,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 1610.78,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1624.41,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 1638.04,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1651.68,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 1665.31,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 1678.95,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 1692.58,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 1706.21,
    y: 1334.38,
    width: 3.81,
    height: 20.04,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1788.71,970.38c-8,25.31-22.85,34.63-35,30.82-12.38-3.89-18.38-20-11.26-43.11,7.15-22.72,21.51-34.64,35.11-30.36C1791.62,932.13,1795.5,948.78,1788.71,970.38Zm-50.54,81.32,90.31-108,9.52,3-90.31,108Zm17.35-90.33c-4.49,13.81-4,25.12,2.65,27.21s12.95-6.48,17.54-21.07c4.18-13.29,4.83-24.86-2.38-27.13C1766.53,938.24,1759.76,947.89,1755.52,961.37Zm78.44,78c-7.89,25.12-22.71,34.67-35,30.82s-18.37-20-11.06-43.26c7.09-22.53,21.51-34.64,35-30.4C1836.93,1001,1840.76,1017.8,1834,1039.41Zm-33.18-9c-4.44,13.63-4,25.13,2.65,27.22s13-6.48,17.54-21.07c4.23-13.48,4.82-24.86-2.38-27.13C1811.78,1007.27,1805,1016.91,1800.78,1030.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1888.86,
    cy: 681.56,
    r: 188.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-164",
    cx: 1889.23,
    cy: 683.6,
    r: 170.43,
    transform: "translate(69.96 1536.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M2066.88,635.9l1.65,142,.26,22a5.24,5.24,0,0,1-5,5.4l-282.12,10a5.23,5.23,0,0,1-5.4-5l-1.1-22-7-140.08c-.1-2.87,3.08-8.59,9.28-8.38l275.47-16.87a13.15,13.15,0,0,1,14,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2054.34,639.57l1.54,132.29.24,20.48a4.88,4.88,0,0,1-4.69,5l-262.81,9.28a4.88,4.88,0,0,1-5-4.68l-1-20.46L1776.07,651c-.1-2.67,2.87-8,8.65-7.8l256.61-15.72a12.26,12.26,0,0,1,13,12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2026.71,803.42a.93.93,0,0,1-.92-.9.92.92,0,0,1,.89-.95l30.08-1.06a7.64,7.64,0,0,0,6.88-7.42l-3.25-92a.92.92,0,0,1,.89-1,.91.91,0,0,1,1,.89l3.24,92a9.46,9.46,0,0,1-8.65,9.32l-30.09,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1777.68,712a.93.93,0,0,1-.92-.89l-2-55.16c-.21-6.13,4.36-11.48,10-11.68l23.9-.84a.92.92,0,1,1,.06,1.84l-23.9.85c-4.55.16-8.39,4.72-8.21,9.77l1.95,55.15a.93.93,0,0,1-.89,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 1800.63,
    y: 699.91,
    width: 45.31,
    height: 36.97,
    rx: 5.22,
    transform: "translate(-24.21 64.77) rotate(-2.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1816.7,726.11a2.51,2.51,0,0,1-2.51-2.42l-.3-8.75a2.45,2.45,0,0,1,.67-1.8,2.48,2.48,0,0,1,1.75-.79l9.93-.36a2.51,2.51,0,0,1,2.6,2.42h0l.31,8.75a2.52,2.52,0,0,1-2.42,2.6l-9.94.35Zm9.63-12.27h0l-9.94.35a.66.66,0,0,0-.46.21.7.7,0,0,0-.18.48l.31,8.74a.7.7,0,0,0,.21.47.65.65,0,0,0,.48.17l9.93-.35a.65.65,0,0,0,.64-.68l-.3-8.75A.67.67,0,0,0,1826.33,713.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1800.58,718.33a.91.91,0,0,1-.92-.89.93.93,0,0,1,.89-1l14.3-.5a.92.92,0,1,1,.06,1.84l-14.3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1800.7,721.9a.92.92,0,0,1-.92-.89.91.91,0,0,1,.89-1l14.3-.51a.93.93,0,1,1,.07,1.85l-14.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.37,717.28a.93.93,0,0,1,0-1.85l15.49-.55a.91.91,0,0,1,1,.89.93.93,0,0,1-.89,1l-15.5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.5,720.85a.93.93,0,0,1-.93-.89.94.94,0,0,1,.89-1l15.5-.54a.92.92,0,1,1,.06,1.84l-15.49.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1818,714.19a.92.92,0,0,1-.89-.68l-3.53-12.86a.92.92,0,1,1,1.78-.49L1818.9,713a.93.93,0,0,1-.65,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1826.31,713.9l-.18,0a.94.94,0,0,1-.72-1.1l2.73-13.08a.91.91,0,0,1,1.09-.71.92.92,0,0,1,.72,1.09l-2.73,13.08A.93.93,0,0,1,1826.31,713.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1815.79,738.53l-.18,0a.92.92,0,0,1-.72-1.09l2.61-13.07a.92.92,0,1,1,1.81.36l-2.61,13.08A.93.93,0,0,1,1815.79,738.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.35,738a.91.91,0,0,1-.88-.67l-3.65-12.85a.93.93,0,0,1,1.78-.51l3.64,12.86a.92.92,0,0,1-.63,1.14A1.15,1.15,0,0,1,1830.35,738Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1792.82,
    y: 659.5,
    width: 51.28,
    height: 13.12,
    rx: 6.2,
    transform: "translate(-22.37 64.57) rotate(-2.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1851,758.63a5.93,5.93,0,0,1-5.71,6.12l-43,1.52a5.91,5.91,0,0,1-6.12-5.71v-.09a5.92,5.92,0,0,1,5.71-6.12l43-1.52a5.91,5.91,0,0,1,6.12,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1912.92,756.44a5.91,5.91,0,0,1-5.7,6.12l-43,1.52a5.91,5.91,0,0,1-6.12-5.71v-.09a5.93,5.93,0,0,1,5.71-6.12l43-1.52a5.92,5.92,0,0,1,6.12,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1974.89,754.25a5.91,5.91,0,0,1-5.7,6.12l-43,1.52a5.92,5.92,0,0,1-6.13-5.7v-.09a5.93,5.93,0,0,1,5.71-6.13l43-1.51a5.91,5.91,0,0,1,6.12,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2038.06,752a5.91,5.91,0,0,1-5.71,6.12l-43,1.52a5.91,5.91,0,0,1-6.12-5.7v-.09a5.93,5.93,0,0,1,5.71-6.13l43-1.51a5.91,5.91,0,0,1,6.12,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1892.4,783.43a4.71,4.71,0,0,1-4.54,4.87l-80,2.83a4.71,4.71,0,0,1-4.87-4.54v-.13a4.7,4.7,0,0,1,4.53-4.87l80-2.82a4.72,4.72,0,0,1,4.87,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1992.34,772.07h34.71a4.71,4.71,0,0,1,4.71,4.71v.13a4.7,4.7,0,0,1-4.7,4.7h-34.71a4.71,4.71,0,0,1-4.71-4.71v-.13a4.7,4.7,0,0,1,4.7-4.7Z",
    transform: "translate(-26.16 71.38) rotate(-2.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-169",
    cx: 1847.25,
    cy: 559.19,
    r: 43.05,
    transform: "translate(344.02 1769.69) rotate(-55.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-170",
    cx: 1847.25,
    cy: 559.19,
    r: 41.61,
    transform: "translate(-74.34 739.48) rotate(-22.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1812.93,543.52a1.62,1.62,0,0,1-1.44-2.35,39.84,39.84,0,0,1,35.75-22,40.39,40.39,0,0,1,7.22.65,1.62,1.62,0,1,1-.57,3.18,36.85,36.85,0,0,0-39.52,19.64A1.61,1.61,0,0,1,1812.93,543.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 1848.15,
    cy: 560.09,
    r: 35.22,
    transform: "translate(145.26 1470.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1844.7,586.28v-3.83a31.25,31.25,0,0,1-10.76-2.34,2.2,2.2,0,0,1-1.22-2.61l1-3.57a2.24,2.24,0,0,1,3-1.47,26,26,0,0,0,9.93,2.1c3.85,0,6.72-1.31,6.72-4,0-2.42-2.22-3.85-7.57-5.28-7.63-2.09-13.1-5.42-13.1-12.13,0-6.07,4.43-10.7,12.13-11.94V537.4a2.23,2.23,0,0,1,2.23-2.23h2.25a2.23,2.23,0,0,1,2.23,2.23v3.44a28.63,28.63,0,0,1,8.53,1.53,2.21,2.21,0,0,1,1.38,2.68l-.89,3.3a2.23,2.23,0,0,1-2.94,1.51,23.14,23.14,0,0,0-8.36-1.52c-4.56,0-5.87,1.89-5.87,3.59,0,2.08,2.74,3.52,8.67,5.34,8.48,2.55,12,6.07,12,12.39,0,5.81-4.3,11-12.65,12.33v4.29a2.23,2.23,0,0,1-2.23,2.23h-2.25A2.23,2.23,0,0,1,1844.7,586.28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-172",
    cx: 1969.77,
    cy: 508.14,
    r: 74.93,
    transform: "translate(217.62 1541.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-173",
    cx: 1969.77,
    cy: 508.14,
    r: 72.44,
    transform: "translate(1035.49 2315.16) rotate(-77.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1910,479.66a1.57,1.57,0,0,1-.73-.17,1.6,1.6,0,0,1-.71-2.17,68.18,68.18,0,0,1,61.17-37.67,69.88,69.88,0,0,1,12.36,1.11,1.62,1.62,0,1,1-.58,3.18,66.17,66.17,0,0,0-11.78-1.06,65,65,0,0,0-58.29,35.9A1.6,1.6,0,0,1,1910,479.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 1971.35,
    cy: 509.72,
    r: 61.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M1965.34,555.3v-6.67a54.36,54.36,0,0,1-18.72-4.06,3.85,3.85,0,0,1-2.13-4.56l1.69-6.21a3.89,3.89,0,0,1,5.28-2.55,45,45,0,0,0,17.28,3.64c6.7,0,11.69-2.27,11.69-6.92,0-4.2-3.85-6.7-13.16-9.2-13.29-3.63-22.82-9.42-22.82-21.11,0-10.56,7.72-18.62,21.11-20.78v-6.67a3.89,3.89,0,0,1,3.89-3.88h3.92a3.89,3.89,0,0,1,3.89,3.88v6a49.47,49.47,0,0,1,14.83,2.67,3.85,3.85,0,0,1,2.42,4.66l-1.56,5.75a3.88,3.88,0,0,1-5.12,2.62,40.33,40.33,0,0,0-14.55-2.64c-7.94,0-10.21,3.29-10.21,6.24,0,3.63,4.76,6.13,15.09,9.31,14.76,4.43,20.89,10.56,20.89,21.57,0,10.1-7.49,19.18-22,21.46v7.46a3.89,3.89,0,0,1-3.89,3.89h-3.92A3.89,3.89,0,0,1,1965.34,555.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-175",
    cx: 2021.45,
    cy: 675.51,
    r: 77.11,
    transform: "translate(721.26 2364.32) rotate(-70.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 2021.45,
    cy: 675.51,
    r: 74.54,
    transform: "translate(337.2 1981.61) rotate(-56.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1960,646.16a1.57,1.57,0,0,1-.73-.17,1.62,1.62,0,0,1-.72-2.17,70.15,70.15,0,0,1,62.91-38.74,70.94,70.94,0,0,1,12.71,1.15,1.62,1.62,0,0,1-.58,3.18,67.33,67.33,0,0,0-72.15,35.86A1.6,1.6,0,0,1,1960,646.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 2023.08,
    cy: 677.14,
    r: 63.09,
    transform: "translate(863.2 2467.67) rotate(-75.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M2016.89,724v-6.87a55.78,55.78,0,0,1-19.26-4.17,4,4,0,0,1-2.2-4.69l1.75-6.4a4,4,0,0,1,5.43-2.61,46.48,46.48,0,0,0,17.78,3.74c6.89,0,12-2.34,12-7.13,0-4.32-4-6.89-13.55-9.46-13.66-3.74-23.48-9.69-23.48-21.73,0-10.86,7.95-19.15,21.73-21.37v-6.87a4,4,0,0,1,4-4h4a4,4,0,0,1,4,4v6.17a50.76,50.76,0,0,1,15.27,2.74,4,4,0,0,1,2.49,4.8l-1.61,5.91a4,4,0,0,1-5.26,2.7,41.68,41.68,0,0,0-15-2.72c-8.17,0-10.51,3.39-10.51,6.42,0,3.74,4.91,6.31,15.54,9.58,15.18,4.56,21.49,10.87,21.49,22.2,0,10.39-7.71,19.74-22.66,22.08V724a4,4,0,0,1-4,4h-4A4,4,0,0,1,2016.89,724Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 2120.37,
    cy: 570.48,
    r: 56.5,
    transform: "translate(1345.97 2625.16) rotate(-84.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-179",
    cx: 2120.37,
    cy: 570.48,
    r: 54.62,
    transform: "translate(528.63 2083.01) rotate(-58.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M2075.33,549.4a1.55,1.55,0,0,1-.72-.17,1.61,1.61,0,0,1-.72-2.17,51.82,51.82,0,0,1,46.48-28.62,52.47,52.47,0,0,1,9.39.85,1.62,1.62,0,1,1-.58,3.18,48.91,48.91,0,0,0-52.4,26A1.62,1.62,0,0,1,2075.33,549.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 2121.56,
    cy: 571.67,
    r: 46.23,
    transform: "translate(-39.67 175.58) rotate(-4.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M2117,606v-5a40.89,40.89,0,0,1-14.12-3.06,2.9,2.9,0,0,1-1.6-3.43l1.27-4.69a2.93,2.93,0,0,1,4-1.92,34.13,34.13,0,0,0,13,2.75c5,0,8.82-1.72,8.82-5.23,0-3.16-2.91-5-9.93-6.93-10-2.74-17.2-7.1-17.2-15.92,0-8,5.82-14,15.92-15.66v-5a2.93,2.93,0,0,1,2.93-2.93h2.95a2.93,2.93,0,0,1,2.93,2.93v4.52a37.12,37.12,0,0,1,11.19,2,2.92,2.92,0,0,1,1.82,3.52l-1.18,4.33a2.91,2.91,0,0,1-3.85,2,30.65,30.65,0,0,0-11-2c-6,0-7.71,2.48-7.71,4.71,0,2.74,3.6,4.62,11.39,7,11.12,3.33,15.75,7.95,15.75,16.26,0,7.61-5.65,14.46-16.61,16.17V606a2.93,2.93,0,0,1-2.93,2.93H2120A2.93,2.93,0,0,1,2117,606Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 549.07,
    cy: 283.83,
    r: 198.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 549.47,
    cy: 285.98,
    r: 179.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 433.28,
    y: 150.39,
    width: 239.08,
    height: 472.57,
    rx: 12.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 449.83,
    y: 169.69,
    width: 208.18,
    height: 182.99,
    rx: 28.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 456.03,
    y: 174.52,
    width: 196.64,
    height: 173.3,
    rx: 21.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M630.57,241.2H585.38a13,13,0,0,1-13-13h0a13,13,0,0,1,13-13h45.19a13,13,0,0,1,13,13h0A13,13,0,0,1,630.57,241.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M630.57,286.76H585.38a13,13,0,0,1-13-13h0a13,13,0,0,1,13-13h45.19a13,13,0,0,1,13,13h0A13,13,0,0,1,630.57,286.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M631.06,330.68H585.87a13,13,0,0,1-13-13h0a13,13,0,0,1,13-13h45.19a13,13,0,0,1,13,13h0A13,13,0,0,1,631.06,330.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 456.03,
    y: 197.86,
    width: 196.64,
    height: 1.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M640.64,396.48h-71.1a2,2,0,0,1-1.83-3l2.86-5.72a2,2,0,0,1,1.83-1.13h65.19a2,2,0,0,1,1.8,1.08l3.06,5.72A2,2,0,0,1,640.64,396.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M639.18,387.76H570.65a1.69,1.69,0,0,1-1.68-1.69h0a1.68,1.68,0,0,1,1.68-1.68h68.53a1.68,1.68,0,0,1,1.68,1.68h0A1.69,1.69,0,0,1,639.18,387.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 491.44,
    y: 352.5,
    width: 41.28,
    height: 87.96,
    transform: "translate(113.71 907.1) rotate(-89.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M472.92,408.21l.08-23.46a3.78,3.78,0,0,0,3.5-3.88c0-.07,0,0,0-.3l71,.26v.3a3.66,3.66,0,0,0,3.43,3.85s.05,0,.05,0L550.89,408c-3.23,0-3.53,2.2-3.54,4.29a.25.25,0,0,0,0,.14l-71-.27V412A3.66,3.66,0,0,0,472.92,408.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M499.15,396.56A12.91,12.91,0,1,1,512,409.51,12.92,12.92,0,0,1,499.15,396.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M513.39,387.91v1.36a10.81,10.81,0,0,1,3.82.85.78.78,0,0,1,.44.93l-.36,1.27a.8.8,0,0,1-1.08.52,9.12,9.12,0,0,0-3.53-.76c-1.37,0-2.39.45-2.4,1.41s.79,1.37,2.69,1.89c2.71.75,4.66,1.94,4.65,4.33,0,2.16-1.59,3.8-4.33,4.24v1.36a.79.79,0,0,1-.8.79h-.8a.79.79,0,0,1-.79-.8v-1.22a10.24,10.24,0,0,1-3-.56.79.79,0,0,1-.49-1l.33-1.17a.79.79,0,0,1,1-.53,8.59,8.59,0,0,0,3,.55c1.62,0,2.09-.67,2.09-1.27s-1-1.26-3.08-1.92c-3-.91-4.26-2.17-4.25-4.42,0-2.07,1.54-3.92,4.52-4.37V387.9a.79.79,0,0,1,.8-.79h.8A.79.79,0,0,1,513.39,387.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M553.7,415.4h0L532,415.32a.69.69,0,1,1,0-1.38h0l21,.08,0-7.27a.7.7,0,0,1,.69-.68.69.69,0,0,1,.69.69l0,8A.68.68,0,0,1,553.7,415.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M470.7,386.9h0a.69.69,0,0,1-.69-.69l0-8a.71.71,0,0,1,.21-.49.9.9,0,0,1,.48-.2l21.46.08a.68.68,0,0,1,.68.69.69.69,0,0,1-.69.69h0l-20.76-.08,0,7.27A.69.69,0,0,1,470.7,386.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M534.76,395.5a3.66,3.66,0,1,1,3.64,3.66A3.65,3.65,0,0,1,534.76,395.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M479.77,395.29a3.66,3.66,0,1,1,3.64,3.67A3.65,3.65,0,0,1,479.77,395.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M555.69,378.7H466.84a3.26,3.26,0,0,1-3.25-3.25h0a3.26,3.26,0,0,1,3.25-3.26h88.85a3.25,3.25,0,0,1,3.25,3.26h0A3.25,3.25,0,0,1,555.69,378.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 478.5,
    y: 275.91,
    width: 17.99,
    height: 11.27,
    rx: 4.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 478.5,
    y: 287.94,
    width: 17.99,
    height: 11.27,
    rx: 5.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 478.5,
    y: 299.9,
    width: 17.99,
    height: 11.27,
    rx: 4.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 478.5,
    y: 311.93,
    width: 17.99,
    height: 11.27,
    rx: 4.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 499.15,
    y: 276.25,
    width: 17.99,
    height: 11.27,
    rx: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 499.15,
    y: 288.29,
    width: 17.99,
    height: 11.27,
    rx: 4.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 499.15,
    y: 300.24,
    width: 17.99,
    height: 11.27,
    rx: 4.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 499.15,
    y: 312.28,
    width: 17.99,
    height: 11.27,
    rx: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 518.88,
    y: 276.36,
    width: 17.99,
    height: 11.27,
    rx: 4.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 518.88,
    y: 288.39,
    width: 17.99,
    height: 11.27,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 518.88,
    y: 300.35,
    width: 17.99,
    height: 11.27,
    rx: 4.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 518.88,
    y: 312.38,
    width: 17.99,
    height: 11.27,
    rx: 3.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 538.86,
    y: 275.57,
    width: 17.99,
    height: 11.27,
    rx: 3.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 538.86,
    y: 287.6,
    width: 17.99,
    height: 11.27,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 538.86,
    y: 299.56,
    width: 17.99,
    height: 11.27,
    rx: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 538.86,
    y: 311.59,
    width: 17.99,
    height: 11.27,
    rx: 3.12
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 250.51,
    cy: 658.26,
    r: 170.29,
    transform: "translate(-392.09 369.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-191",
    cx: 250.84,
    cy: 660.11,
    r: 154.09,
    transform: "translate(-393.3 370.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 158.76,
    y: 425.39,
    width: 208.7,
    height: 360.51,
    rx: 27.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 168.31,
    y: 436.59,
    width: 189.6,
    height: 338.28,
    rx: 27.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M315.7,447H211.75a5.48,5.48,0,0,1-5.47-5.46h0a5.48,5.48,0,0,1,5.47-5.47h104a5.48,5.48,0,0,1,5.47,5.47h0A5.48,5.48,0,0,1,315.7,447Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.08,441.57H232a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h66a2,2,0,0,1,2,2h0A2,2,0,0,1,298.08,441.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 220.02,
    y: 588.9,
    width: 88.21,
    height: 33.32,
    rx: 16.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M239.37,596.19a28.65,28.65,0,0,1,5.07-.4c2.58,0,4.17.32,5.47,1.22a4,4,0,0,1,2,3.57,4.43,4.43,0,0,1-3.17,4.14v.06a4.82,4.82,0,0,1,3.85,4.73,5,5,0,0,1-1.84,3.94c-1.36,1.19-3.6,1.79-7.08,1.79a32.21,32.21,0,0,1-4.28-.26Zm3.45,7.54h1.79c2.41,0,3.77-1.13,3.77-2.75,0-1.78-1.36-2.61-3.57-2.61a9.05,9.05,0,0,0-2,.15Zm0,8.79a17.36,17.36,0,0,0,1.85.08c2.23,0,4.22-.85,4.22-3.2s-1.93-3.12-4.34-3.12h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M259.14,595.94v11.13c0,3.75,1.56,5.47,3.92,5.47,2.52,0,4-1.72,4-5.47V595.94h3.49v10.91c0,5.89-3,8.5-7.63,8.5-4.42,0-7.28-2.47-7.28-8.47V595.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M278.9,615v-8l-6-11.13h4l2.29,4.9c.65,1.42,1.14,2.49,1.65,3.8h.05c.49-1.22,1-2.41,1.68-3.8l2.29-4.9h3.94l-6.35,11v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M308.63,495.17a2.9,2.9,0,0,0-2.36-.95L221.76,496l-2.14-6.78a2.19,2.19,0,0,0-2.19-1.52l-11.6.3a2.19,2.19,0,0,0-2.25,2.14,2.05,2.05,0,0,0,2.25,2l9.92-.23,17.94,57.33a2.37,2.37,0,0,0,2.23,1.64l59.32.8a2.28,2.28,0,0,0,2.52-2.17,2.35,2.35,0,0,0-2.52-2.24l-57.59-.62L233,531.79l63.28.09a2.92,2.92,0,0,0,2.8-2l10-32.29A2.55,2.55,0,0,0,308.63,495.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M244.6,554.44a8.55,8.55,0,0,0-8.83,8.46,9,9,0,0,0,8.83,8.84,8.56,8.56,0,0,0,8.93-8.47A9,9,0,0,0,244.6,554.44Zm0,12.69a4.21,4.21,0,0,1-4.13-4.13,4,4,0,0,1,4.13-4,4.19,4.19,0,0,1,4.15,4.12A4,4,0,0,1,244.6,567.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M284.14,555.05a8.89,8.89,0,0,0-9.27,8.67,9.35,9.35,0,0,0,9.27,9.06,8.89,8.89,0,0,0,9.37-8.67A9.35,9.35,0,0,0,284.14,555.05Zm0,13a4.36,4.36,0,0,1-4.34-4.23,4.15,4.15,0,0,1,4.34-4A4.36,4.36,0,0,1,288.5,564,4.14,4.14,0,0,1,284.14,568.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-197",
    cx: 251.9,
    cy: 695.37,
    r: 24.16,
    transform: "translate(-480.05 589.35) rotate(-61.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-198",
    cx: 251.9,
    cy: 695.37,
    r: 23.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M232.64,686.58a1.07,1.07,0,0,1-.41-.1.92.92,0,0,1-.4-1.22A22.39,22.39,0,0,1,251.9,672.9a22.88,22.88,0,0,1,4.06.37.91.91,0,1,1-.33,1.78,21,21,0,0,0-3.73-.33,20.57,20.57,0,0,0-18.45,11.36A.92.92,0,0,1,232.64,686.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 252.41,
    cy: 695.88,
    r: 19.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M250.47,710.58v-2.15a17.49,17.49,0,0,1-6-1.31,1.25,1.25,0,0,1-.69-1.47l.55-2a1.26,1.26,0,0,1,1.7-.82,14.45,14.45,0,0,0,5.57,1.18c2.16,0,3.77-.73,3.77-2.24,0-1.35-1.24-2.16-4.24-3-4.29-1.17-7.36-3-7.36-6.81,0-3.4,2.49-6,6.81-6.7v-2.15a1.25,1.25,0,0,1,1.25-1.25h1.26a1.25,1.25,0,0,1,1.26,1.25v1.93a16.26,16.26,0,0,1,4.78.86,1.26,1.26,0,0,1,.78,1.51l-.5,1.85a1.24,1.24,0,0,1-1.65.84,13.29,13.29,0,0,0-4.7-.85c-2.56,0-3.29,1.06-3.29,2,0,1.17,1.54,2,4.87,3,4.76,1.42,6.73,3.4,6.73,7,0,3.26-2.41,6.19-7.1,6.92v2.41a1.25,1.25,0,0,1-1.25,1.25h-1.26A1.25,1.25,0,0,1,250.47,710.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-201",
    cx: 320.68,
    cy: 666.72,
    r: 42.06,
    transform: "translate(-377.52 422.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-202",
    cx: 320.68,
    cy: 666.72,
    r: 40.66,
    transform: "translate(-401.88 825.64) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M287.15,650.74a1,1,0,0,1-.41-.1.9.9,0,0,1-.4-1.22,38.28,38.28,0,0,1,34.34-21.14,39.08,39.08,0,0,1,6.93.62.9.9,0,0,1,.73,1.06.91.91,0,0,1-1,.73A36.65,36.65,0,0,0,288,650.24.92.92,0,0,1,287.15,650.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 321.56,
    cy: 667.61,
    r: 34.42,
    transform: "translate(-377.88 422.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M318.19,693.19v-3.74a30.6,30.6,0,0,1-10.51-2.28,2.17,2.17,0,0,1-1.2-2.56l1-3.49a2.18,2.18,0,0,1,3-1.43,25.36,25.36,0,0,0,9.7,2c3.76,0,6.56-1.28,6.56-3.89,0-2.36-2.16-3.76-7.39-5.16-7.45-2-12.81-5.29-12.81-11.85,0-5.93,4.34-10.45,11.86-11.67v-3.74a2.18,2.18,0,0,1,2.18-2.18h2.2a2.19,2.19,0,0,1,2.18,2.18v3.36a27.83,27.83,0,0,1,8.33,1.5,2.17,2.17,0,0,1,1.35,2.62l-.87,3.22a2.17,2.17,0,0,1-2.87,1.47,22.92,22.92,0,0,0-8.17-1.48c-4.46,0-5.74,1.85-5.74,3.5,0,2,2.68,3.45,8.48,5.23,8.28,2.48,11.72,5.93,11.72,12.11,0,5.67-4.2,10.77-12.36,12v4.19a2.19,2.19,0,0,1-2.18,2.18h-2.2A2.18,2.18,0,0,1,318.19,693.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-204",
    cx: 349.69,
    cy: 760.66,
    r: 43.28,
    transform: "translate(-486.89 792.64) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-205",
    cx: 349.69,
    cy: 760.66,
    r: 41.84,
    transform: "translate(-479.67 874.92) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M315.18,744.19a.85.85,0,0,1-.4-.1.9.9,0,0,1-.4-1.22,39.34,39.34,0,0,1,35.31-21.74,40.48,40.48,0,0,1,7.13.64.91.91,0,1,1-.33,1.79A37.81,37.81,0,0,0,316,743.69.88.88,0,0,1,315.18,744.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 350.6,
    cy: 761.57,
    r: 35.41,
    transform: "translate(-457.3 985.65) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M347.12,787.9v-3.85a31.31,31.31,0,0,1-10.81-2.35,2.22,2.22,0,0,1-1.23-2.63l1-3.59a2.26,2.26,0,0,1,3.05-1.47,26,26,0,0,0,10,2.1c3.87,0,6.75-1.31,6.75-4,0-2.42-2.23-3.86-7.6-5.31-7.67-2.09-13.18-5.44-13.18-12.19,0-6.1,4.46-10.75,12.19-12v-3.85a2.25,2.25,0,0,1,2.25-2.25h2.26a2.25,2.25,0,0,1,2.25,2.25v3.46a28.61,28.61,0,0,1,8.57,1.53,2.23,2.23,0,0,1,1.39,2.7l-.9,3.32a2.23,2.23,0,0,1-2.95,1.51,23.35,23.35,0,0,0-8.41-1.52c-4.59,0-5.9,1.9-5.9,3.6,0,2.1,2.76,3.54,8.72,5.38,8.53,2.56,12.07,6.1,12.07,12.46,0,5.83-4.33,11.08-12.72,12.39v4.31a2.25,2.25,0,0,1-2.25,2.25h-2.26A2.25,2.25,0,0,1,347.12,787.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-207",
    cx: 405.21,
    cy: 701.71,
    r: 31.71,
    transform: "translate(-370.83 934.86) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-208",
    cx: 405.21,
    cy: 701.71,
    r: 30.66,
    transform: "translate(-404.73 677.49) rotate(-58.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M379.93,689.88a.86.86,0,0,1-.41-.1.9.9,0,0,1-.4-1.22A29.22,29.22,0,0,1,410.48,673a.91.91,0,1,1-.33,1.78,28.09,28.09,0,0,0-4.94-.44,27.28,27.28,0,0,0-24.47,15.06A.9.9,0,0,1,379.93,689.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 405.88,
    cy: 702.38,
    r: 25.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M403.33,721.66v-2.82a23,23,0,0,1-7.92-1.72,1.61,1.61,0,0,1-.9-1.92l.71-2.63a1.65,1.65,0,0,1,2.24-1.08,19.09,19.09,0,0,0,7.31,1.54c2.84,0,5-1,5-2.93,0-1.78-1.63-2.84-5.57-3.89-5.62-1.54-9.66-4-9.66-8.94,0-4.47,3.27-7.88,8.94-8.79v-2.82a1.64,1.64,0,0,1,1.64-1.65h1.66a1.64,1.64,0,0,1,1.64,1.65v2.53a21,21,0,0,1,6.28,1.13,1.63,1.63,0,0,1,1,2l-.65,2.43a1.64,1.64,0,0,1-2.17,1.1,17.35,17.35,0,0,0-6.16-1.11c-3.36,0-4.32,1.39-4.32,2.64,0,1.54,2,2.59,6.39,3.94,6.24,1.87,8.84,4.47,8.84,9.13,0,4.27-3.17,8.11-9.32,9.08v3.15a1.65,1.65,0,0,1-1.65,1.65H405A1.65,1.65,0,0,1,403.33,721.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 381.7,
    cy: 1193.29,
    r: 194.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-210",
    cx: 382.08,
    cy: 1195.4,
    r: 175.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M332.89,1172.65c-1.49.29,11.34,218.52,21.17,267.66l20.41-1.51L379,1218h7.56l11.34,217h16.64l15.88-264.64S366.91,1165.84,332.89,1172.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M354.06,1454.68s16.63,2.27,26.46,0c0,0,3-8.32-6-15.88s-20.41,1.51-20.41,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M397.91,1435s-.75,12.1,0,18.15c0,0,31.76,1.06,49.22,1a3,3,0,0,0,1.17-5.68c-5.61-2.49-15.68-10.75-33.75-13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M339.69,996.47s43.86-14.36,78.64-1.51l17.39,182.22s-77.88-2.26-104.34,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M301.13,1011.59s25.71-14.36,49.9-18.14l-7.25,185a10,10,0,0,1-8,9.39l-2.58.51a3.93,3.93,0,0,1-4.7-4l2.27-78.08a100.27,100.27,0,0,0-7.52-41.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M406.23,991.93S444,995,466,1014.62l-17,48.12a151.12,151.12,0,0,0-8.66,50.42l-3.59,69.37a3.93,3.93,0,0,1-3.93,3.73h0a10,10,0,0,1-9.93-9.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M363.89,969.25l-.65,21.54a4.88,4.88,0,0,0,3.26,4.76c5.51,1.94,16.91,4.9,27.72,1a4.86,4.86,0,0,0,3.15-5.3l-3.24-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M354.82,929.93s3.78,38.57,12.09,48.39c0,0,24.95,2.27,34-3a143.25,143.25,0,0,0,5.67-45S407.85,906.92,382,905C351.79,902.71,354.82,929.93,354.82,929.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M404,942s2.27-6.8,6.05-6.8-.75,18.14-6.05,18.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M358.26,943.82s-3.17-6.44-6.92-5.93,3.2,17.88,8.45,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M357.43,950.28s.84,23,11,34.71a5.21,5.21,0,0,0,3.7,1.77c5.17.25,18.39.69,25.84-.79a5.28,5.28,0,0,0,4-3.47c1.84-5.37,5-13.85,3.92-33.29l-6.08,14.49c-4.5,12-6.95-2.56-9-2.39H377.12c-1.43.12-3,9.08-8.34,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M396.4,920.86s-19.26,19.81-40.25,19.74c0,0-11.92-31.84,11.52-37.13S391.86,905,391.86,905s27.41-6.73,15.22,32.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M388.84,1460a2.27,2.27,0,0,1-2.27-2.27V1136.35a2.27,2.27,0,0,1,4.54,0V1457.7A2.27,2.27,0,0,1,388.84,1460Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M398.67,1131.82s43.1,24.19,53.68-6.81-9.07-50.66-9.07-50.66L466,1014.62s43.1,79.39,12.86,127.78c-28.34,45.34-78.64,3.78-78.64,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M301.13,1011.59s-40.83,136.11,0,154.25S376,1140.13,376,1140.13l-4.54-12.85s-37.05,21.17-49.15,10.59,8.32-72.59,8.32-72.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M400.18,1146.18s-8.32.76-12.85-3.78-9.08-12.85-2.27-13.61,13.61,3,13.61,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M403.21,1131.82s-19.66-12.1-31.76-4.54c0,0-2.27,9.07,4.54,12.85,0,0,12.09,8.32,21.92,3.78S403.21,1131.82,403.21,1131.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-221",
    cx: 298.28,
    cy: 1190.06,
    r: 39.77,
    transform: "translate(-870.86 818.14) rotate(-58.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-222",
    cx: 298.28,
    cy: 1190.06,
    r: 38.45,
    transform: "translate(-432.71 204.73) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M266.57,1175.58a1.49,1.49,0,0,1-1.33-2.16,36.82,36.82,0,0,1,33-20.34,38.11,38.11,0,0,1,6.67.59,1.49,1.49,0,1,1-.54,2.94,34.85,34.85,0,0,0-6.13-.55,33.85,33.85,0,0,0-30.37,18.7A1.51,1.51,0,0,1,266.57,1175.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 299.11,
    cy: 1190.9,
    r: 32.54,
    transform: "translate(-754.48 560.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M295.92,1215.09v-3.54a29,29,0,0,1-9.93-2.15,2.06,2.06,0,0,1-1.14-2.42l.9-3.3a2.07,2.07,0,0,1,2.81-1.35,23.9,23.9,0,0,0,9.17,1.93c3.55,0,6.2-1.21,6.2-3.68,0-2.23-2-3.55-7-4.88-7.05-1.92-12.12-5-12.12-11.2,0-5.61,4.1-9.88,11.21-11v-3.54a2.06,2.06,0,0,1,2.06-2.06h2.08a2.07,2.07,0,0,1,2.07,2.06v3.18a26.53,26.53,0,0,1,7.87,1.41,2.06,2.06,0,0,1,1.28,2.48l-.82,3a2.06,2.06,0,0,1-2.72,1.39,21.41,21.41,0,0,0-7.72-1.4c-4.22,0-5.42,1.75-5.42,3.31,0,1.93,2.53,3.26,8,4.94,7.83,2.35,11.09,5.61,11.09,11.45,0,5.36-4,10.18-11.69,11.39v4a2.07,2.07,0,0,1-2.07,2.06H298A2.06,2.06,0,0,1,295.92,1215.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-224",
    cx: 190.9,
    cy: 1248.47,
    r: 58.41,
    transform: "translate(-826.89 500.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-225",
    cx: 190.9,
    cy: 1248.47,
    r: 56.47,
    transform: "translate(-1035.59 947.07) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M144.34,1226.27a1.31,1.31,0,0,1-.57-.13,1.25,1.25,0,0,1-.55-1.69,53.14,53.14,0,0,1,47.68-29.37,54.23,54.23,0,0,1,9.63.87,1.26,1.26,0,1,1-.45,2.48,50.91,50.91,0,0,0-54.61,27.15A1.27,1.27,0,0,1,144.34,1226.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 192.13,
    cy: 1249.7,
    r: 47.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M187.44,1285.23V1280a42.65,42.65,0,0,1-14.59-3.16,3,3,0,0,1-1.66-3.56l1.32-4.84a3,3,0,0,1,4.12-2,35.28,35.28,0,0,0,13.47,2.83c5.22,0,9.11-1.77,9.11-5.39,0-3.28-3-5.23-10.26-7.17-10.35-2.83-17.79-7.35-17.79-16.46,0-8.23,6-14.51,16.46-16.19v-5.2a3,3,0,0,1,3-3h3.06a3,3,0,0,1,3,3v4.66a38.58,38.58,0,0,1,11.56,2.08,3,3,0,0,1,1.88,3.64l-1.21,4.48a3,3,0,0,1-4,2,31.53,31.53,0,0,0-11.34-2.06c-6.2,0-8,2.57-8,4.87,0,2.83,3.71,4.78,11.76,7.25,11.51,3.45,16.29,8.23,16.29,16.82,0,7.87-5.84,15-17.17,16.72v5.82a3,3,0,0,1-3,3h-3.06A3,3,0,0,1,187.44,1285.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-227",
    cx: 316.68,
    cy: 1375.81,
    r: 71.24,
    transform: "translate(-1095.08 1367.92) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 316.68,
    cy: 1375.81,
    r: 68.87,
    transform: "translate(-1020.14 921.89) rotate(-58.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M259.89,1348.69a1.49,1.49,0,0,1-1.33-2.17,64.79,64.79,0,0,1,58.12-35.78,65.63,65.63,0,0,1,11.74,1,1.5,1.5,0,0,1,1.2,1.74,1.48,1.48,0,0,1-1.73,1.2,62.57,62.57,0,0,0-11.21-1,61.83,61.83,0,0,0-55.45,34.15A1.51,1.51,0,0,1,259.89,1348.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 318.19,
    cy: 1377.31,
    r: 58.29,
    transform: "translate(-1076.05 1144.2) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M312.47,1420.64v-6.34a51.41,51.41,0,0,1-17.8-3.86,3.67,3.67,0,0,1-2-4.33l1.61-5.91a3.7,3.7,0,0,1,5-2.42,43,43,0,0,0,16.43,3.46c6.37,0,11.12-2.16,11.12-6.58,0-4-3.67-6.37-12.52-8.74-12.63-3.46-21.69-9-21.69-20.08,0-10,7.34-17.7,20.07-19.75v-6.34a3.7,3.7,0,0,1,3.7-3.7h3.72a3.7,3.7,0,0,1,3.7,3.7v5.69a47,47,0,0,1,14.1,2.54,3.67,3.67,0,0,1,2.3,4.43l-1.48,5.47a3.69,3.69,0,0,1-4.87,2.49,38.42,38.42,0,0,0-13.83-2.52c-7.55,0-9.71,3.13-9.71,5.94,0,3.45,4.53,5.83,14.35,8.85,14,4.21,19.86,10,19.86,20.51,0,9.6-7.12,18.24-20.94,20.4v7.09a3.7,3.7,0,0,1-3.69,3.7h-3.73A3.7,3.7,0,0,1,312.47,1420.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-230",
    cx: 408.08,
    cy: 1278.76,
    r: 52.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-231",
    cx: 408.08,
    cy: 1278.76,
    r: 50.46,
    transform: "translate(-911.93 1035.16) rotate(-61.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M366.47,1259.29a1.49,1.49,0,0,1-1.34-2.16,48.16,48.16,0,0,1,51.62-25.66,1.49,1.49,0,0,1-.54,2.94,45.1,45.1,0,0,0-48.41,24.06A1.49,1.49,0,0,1,366.47,1259.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 409.18,
    cy: 1279.86,
    r: 42.71,
    transform: "translate(-199.73 82.07) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M405,1311.61V1307a38,38,0,0,1-13-2.83,2.68,2.68,0,0,1-1.49-3.17l1.18-4.33a2.72,2.72,0,0,1,3.68-1.78,31.37,31.37,0,0,0,12,2.54c4.66,0,8.14-1.58,8.14-4.83,0-2.92-2.69-4.66-9.17-6.4-9.25-2.53-15.89-6.56-15.89-14.71,0-7.35,5.37-13,14.7-14.47v-4.65a2.71,2.71,0,0,1,2.71-2.7h2.73a2.7,2.7,0,0,1,2.71,2.7v4.17a34.53,34.53,0,0,1,10.33,1.86,2.7,2.7,0,0,1,1.69,3.25l-1.09,4a2.7,2.7,0,0,1-3.56,1.82,28.28,28.28,0,0,0-10.14-1.84c-5.53,0-7.12,2.29-7.12,4.35,0,2.53,3.33,4.27,10.52,6.48,10.28,3.09,14.55,7.36,14.55,15,0,7-5.22,13.36-15.34,14.94v5.2a2.71,2.71,0,0,1-2.71,2.71h-2.73A2.7,2.7,0,0,1,405,1311.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M925,608.68h29q17.73,0,25.82,6.88T988,637.45q0,9.87-4.28,16.52A17.22,17.22,0,0,1,972,662v.78q9.65,2.41,13.92,9t4.28,17.57q0,15.48-8.29,24.23t-22.67,8.75H925ZM945,654.4h9.72q6.69,0,9.41-3.58t2.72-10.65q0-7.08-3.11-10.15t-9.8-3.07H945Zm0,17.65v31.81H955.6q6.61,0,9.84-4t3.22-12.52q0-15.25-13.37-15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1059.57,722.37l-6.53-28.7h-29.63l-6.53,28.7H995.73l28.15-114.16h28.69l28.23,114.16Zm-10.5-47.44L1043,648.49q-.54-2.41-2.45-12.09t-2.3-12.95q-1,6.69-2.56,14.74t-8.09,36.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M1170.47,722.37h-25.82L1109.5,640h-1a100.42,100.42,0,0,1,1.94,20.22v62.14h-19.6V608.68h26l34.84,81.49h.85a111.18,111.18,0,0,1-1.48-19.44V608.68h19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M1261.37,722.37h-22.55l-18.66-48.61-8.48,8.48v40.13h-21.15V608.68h21.15v56.37l7.39-17,19.36-39.34h22.63l-26.28,49.22Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingImg1);
export default __webpack_public_path__ + "static/media/banking_img_1.4ea0c02da8c65d22962db562460af8d3.svg";
export { ForwardRef as ReactComponent };